


































































































































































































































































































































































































































































































































































































import store, { Dataset, Enterprise, GrowthRateSources, MonthlyPasture, PastureKeys, Stock } from "../../store";
// import moment, { max } from "moment";
import dayjs from 'dayjs';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import { inv, multiply, mod } from "mathjs";

import AvailableDates, {
  MidpointDates,
  StartDates,
  monthShortNames,
  daysInMonth,
  PeriodLengths,
  AvailableDate
} from "@/common/dates";
import { colors } from "@/common/colors";
import { Vue, Component, Watch } from "vue-property-decorator";
import { Breeds, EnterpriseKeys } from '@/common/Formulas/JSON';
import { getShortBreedName } from '@/common/Formulas/Shared';
import LOCATIONS from '@/data/locations';
import { cleanDate } from "@/filters/filters";

interface Pasture {
  ID: number;
  LocationID: number;
  Pasture: string;
  Weight: number;
  Legume: number;
  Months: number[];
}

const PASTURES: Pasture[] = require("@/data/pastures.json");
const DMDI = require("@/data/dmdi.json");
const DWN = require("@/data/dwn.json");

dayjs.extend(dayOfYear);

const CalculationsProps = Vue.extend({
  props: {
    calcEnterprise: {
      type: String,
      required: true,
    },
    calcVisible: {
      type: Boolean,
      default: true,
      required: true,
    },
    radioVisible: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
});

@Component
export default class Calculations extends CalculationsProps {
  tab = "tab-0";
  enterprise = this.calcEnterprise as EnterpriseKeys;
  minMatingIntervalPeriods = 18;

  created() {
    // console.log("store", store.state);
    this.onEnterpriseChanged();
  }

  // Order is important
  @Watch("enterprise")
  onEnterpriseChanged() {
    const timer = "All calculations (" + this.calcEnterprise + ")"
    // console.time(timer)

    try {
    // Pasture
    this.growth();
    this.weighting();
    this.dmdi();
    // Livestock
    this.conceptionRate();
    this.averageDOYofBirth();
    this.startAges();
    this.agesAtMidpoint();
    this.animalSRW();
    this.mdSolid();
    this.pastureDwn();
    this.defaultWeightForAge();
    this.maxNormalWeight();
    this.defaultDw();
    this.liveWeight();
    this.meanConceptusWeight();
    this.previousMaxWeight();
    this.normalWeight();
    this.weightChange();
    this.neMetab();
    this.meMetabGraze();
    this.pregnancy();
    this.woolGrowth();
    this.lactation();
    this.sucklingJoinPeriod();
    this.headOfStock();
    this.weanedData();
    this.gainKg();
    this.gainZ();
    this.gainAlphaBeta();
    this.offspring();
    this.iterations();
    this.iterationsUnweaned();
    this.iterationsWeaned();
    // Feed
    this.totalDmRequiredAllAnimals();
    this.updateState(); // Update state 1
    setTimeout(() => {
      this.totalDmCombinedEnterprises();
      this.pasture();
      this.supplement();
      this.carryover();
      this.pastureKPI();
      this.liveWeightProducedKPI();
    }, 1000);
    this.updateState(); // Update state 2
    } catch (err) {
      console.log(err)
    }

    // console.timeEnd(timer)
  }

  // Commonly used calcuations
  common: {
    periods: any;
    growth: any;
    weighting: any;
    dmdi: any;
    conceptionRate: any;
    averageDOYofBirth: any;
    startAges: any;
    agesAtMidpoint: any;
    animalSRW: any;
    mdSolid: any;
    pastureDwn: any;
    defaultWeightForAge: any;
    maxNormalWeight: any;
    defaultDw: any;
    liveWeight: any;
    meanConceptusWeight: any;
    previousMaxWeight: any;
    normalWeight: any;
    weightChange: any;
    neMetab: any;
    meMetabGraze: any;
    pregnancy: any;
    woolGrowth: any;
    lactation: any;
    sucklingJoinPeriod: {
      mature: any;
      young: any;
    };
    headOfStock: any;
    weanedData: any;
    gainKg: any;
    gainZ: any;
    gainAlphaBeta: any;
    offspring: any;
    iterations: any;
    iterationsUnweaned: any;
    iterationsWeaned: any;
    Z: any[];
    totalDmReqsKeyValues: any;
    totalDmRequiredAllAnimals: any;
    totalDmCombinedEnterprises: any;
    pasture: any;
    supplement: any;
    carryover: any;
    pastureKPI: any;
    liveWeightProducedKPI: any;
  } = {
    periods: null,
    growth: null,
    weighting: null,
    dmdi: null,
    conceptionRate: null,
    averageDOYofBirth: null,
    startAges: null,
    agesAtMidpoint: null,
    animalSRW: null,
    mdSolid: null,
    pastureDwn: null,
    defaultWeightForAge: null,
    maxNormalWeight: null,
    defaultDw: null,
    liveWeight: null,
    meanConceptusWeight: null,
    previousMaxWeight: null,
    normalWeight: null,
    weightChange: null,
    neMetab: null,
    meMetabGraze: null,
    pregnancy: null,
    woolGrowth: null,
    lactation: null,
    sucklingJoinPeriod: {
      mature: null,
      young: null,
    },
    headOfStock: null,
    weanedData: null,
    gainKg: null,
    gainZ: null,
    gainAlphaBeta: null,
    offspring: null,
    iterations: null,
    iterationsUnweaned: null,
    iterationsWeaned: null,
    Z: [],
    totalDmReqsKeyValues: null,
    totalDmRequiredAllAnimals: null,
    totalDmCombinedEnterprises: null,
    pasture: null,
    supplement: null,
    carryover: null,
    pastureKPI: null,
    liveWeightProducedKPI: null
  };

  // Breed parameters
  get param() {
    const selectedBreed = getShortBreedName(this.getEnterprise.livestock.breed);
    return {
      TWINSA: Breeds.parameters["Twins:a"][selectedBreed],
      TWINSB: Breeds.parameters["Twins:b"][selectedBreed],
      DLF1: Breeds.parameters["DLF(1)"][selectedBreed],
      DLF2: Breeds.parameters["DLF(2)"][selectedBreed],
      BWN: Breeds.parameters["BW:N"][selectedBreed],
      CN1: Breeds.parameters["C(N,1)"][selectedBreed],
      CN2: 0.27,
      CN3: 0.4,
      CM2: Breeds.parameters["C(M,2)"][selectedBreed],
      CM6: Breeds.parameters["C(M,6)"][selectedBreed],
      CP1: Breeds.parameters["C(P,1)"][selectedBreed],
      CP2: Breeds.parameters["C(P,2)"][selectedBreed],
      CP3: Breeds.parameters["C(P,3)"][selectedBreed],
      CP5: Breeds.parameters["C(P,5)"][selectedBreed],
      CP6: Breeds.parameters["C(P,6)"][selectedBreed],
      CP7: Breeds.parameters["C(P,7)"][selectedBreed],
      CP8: Breeds.parameters["C(P,8)"][selectedBreed],
      CP9: Breeds.parameters["C(P,9)"][selectedBreed],
      CP10: Breeds.parameters["C(P,10)"][selectedBreed],
      CP141: Breeds.parameters["C(P,14,1)"][selectedBreed],
      CP142: Breeds.parameters["C(P,14,2)"][selectedBreed],
      CL01: Breeds.parameters["C(L,0,1)"][selectedBreed],
      CL02: Breeds.parameters["C(L,0,2)"][selectedBreed],
      CL1: Breeds.parameters["C(L,1)"][selectedBreed],
      CL2: Breeds.parameters["C(L,2)"][selectedBreed],
      CL3: Breeds.parameters["C(L,3)"][selectedBreed],
      CL6: Breeds.parameters["C(L,6)"][selectedBreed],
      CL12: Breeds.parameters["C(L,12)"][selectedBreed],
      CL13: Breeds.parameters["C(L,13)"][selectedBreed],
      CL14: Breeds.parameters["C(L,14)"][selectedBreed],
      CL21: Breeds.parameters["C(L,21)"][selectedBreed],
      CL22: Breeds.parameters["C(L,22)"][selectedBreed],
      CWA: Breeds.parameters["C(W,A)"][selectedBreed],
      CW6: Breeds.parameters["C(W,6)"][selectedBreed],
      CWB: Breeds.parameters["C(W,B)"][selectedBreed],
      EVGMAX: Breeds.parameters["EVG(max)"][selectedBreed],
      EVGRANGE: Breeds.parameters["EVG(range)"][selectedBreed],
      SRW: Breeds.parameters["SRW"][selectedBreed],
    };
  }

  // N(max) - curvature
  get curvature() {
    return this.param.CN1 / Math.pow(this.livestockWeight, this.param.CN2);
  }

  // Cattle or Sheep
  get getEnterprise() {
    return store.state[this.enterprise] as Enterprise;
  }

  // Stocks
  get stocks() {
    return this.getEnterprise.stock;
  }

  // Livestock weight
  get livestockWeight() {
    return this.getEnterprise.livestock.weight;
  }

  // Gestation length
  get gestationLength() {
    return this.enterprise === "cattle" ? 285 : 150;
  }

  // Gestation periods
  get gestationPeriods() {
    return this.enterprise === "cattle" ? 19 : 10;
  }

  // Periods (half-months) from start date
  get periods() {
    let periodArr: number[] = [];
    for (let i = 0; i < 24; i++) {
      if (i === 0) {
        periodArr.push(
          StartDates.indexOf(
            dayjs(store.state.pasture!.simulation.date).format("D MMM")
          ) + 1
        );
      } else {
        periodArr.push(mod(1 + periodArr[i - 1], 24));
      }
    }
    this.common.periods = periodArr
    return periodArr;
  }

  // Months from start date
  get months() {
    let months: number[] = [];
    for (let period = 0; period < 24; period++) {
      if (period % 2 === 0) {
        months.push(
          dayjs(cleanDate(StartDates[mod(this.periods[period] - 1, 24)], 'D MMM'), 'D MMM').month()
        );
      }
    }
    return months;
  }

  // Pasture Types
  get types() {
    let types: Pasture[] = [];
    let startIndex = PASTURES.map((e: any) => e.LocationID).indexOf(
      store.state.pasture!.simulation.location
    );
    let endIndex = PASTURES.map((e: any) => e.LocationID).indexOf(
      store.state.pasture!.simulation.location + 1
    );
    for (let i = startIndex; i < endIndex; i++) {
      types[i - startIndex] = PASTURES[i];
    }
    store.state.types = types;
    return types;
  }

  // Midpoint DOY
  get midpointDOY() {
    let midpoints: number[] = [];
    for (let i = 0; i < 24; i++) {
      midpoints.push(
        dayjs(cleanDate(MidpointDates[mod(this.periods[i] - 1, 24)], 'D MMM'), 'D MMM').dayOfYear() + 1
      );
    }
    return midpoints;
  }

  // Daylength
  get daylength() {
    const location = LOCATIONS.filter(
      (location: any) => location.ID === store.state.pasture!.simulation.location
    )[0];
    const latitude: number = location.Latitude;
    const midpoints = this.midpointDOY;
    const dlAmplitude =
      (24 / Math.PI) * Math.acos(0.434 * Math.tan((Math.PI * latitude) / 180)) -
      12;

    let daylengths: any[] = [];
    for (let i = 0; i < 24; i++) {
      daylengths.push(
        12.15 +
          dlAmplitude * Math.cos((2 * Math.PI * (midpoints[i] + 10)) / 365)
      );
    }
    return daylengths;
  }

  // Produces Offspring
  get producesOffspring() {
    return ['Cows (>3 years)', 'Cows (2-3 years)', 'Heifers (1-2 years)', 'Ewes (>2 years)', 'Ewes (1-2 years)']
  }

  // Mothers
  get mothers() {
    const cattleMothers = ["Cows (>3 years)", "Cows (2-3 years)"];
    const sheepMothers = ["Ewes (>2 years)"];
    // Join 1-2 year heifers / ewes
    if (this.enterprise === 'cattle') {
      if (this.getEnterprise.livestock.joinOption) {
        cattleMothers.push("Heifers (1-2 years)")
      }
    } else {
      if (this.getEnterprise.livestock.joinOption) {
        sheepMothers.push("Ewes (1-2 years)")
      }
    }
    const mothers = this.enterprise === "cattle" ? cattleMothers : sheepMothers;
    return mothers
  }

  // ------------------------------------------------------------
  // ----------------------- HELPERS ----------------------------
  // ------------------------------------------------------------

  // Remove reactivity from data source
  cleanSource<T>(source: T): T {
    return (JSON.parse(JSON.stringify(source)) as any) as T;
  }

  trim (value:number) {
    return value // raw
    // return parseFloat(value.toFixed(5)); // trimmed
  }

  updateState() {
    this.calcEnterprise === 'cattle'
    ? store.state.calculations.cattle = this.common
    : store.state.calculations.sheep = this.common
    this.calcEnterprise === 'cattle'
    ? store.state.cattle.calculations = this.common
    : store.state.sheep.calculations = this.common
    store.dispatch("updateCattle", store.state.cattle);
    store.dispatch("updateSheep", store.state.sheep);
    store.dispatch("updateCalculations", { cattle: store.state.calculations.cattle, sheep: store.state.calculations.sheep });
  }

  // ------------------------------------------------------------
  // --------------------- CALCULATIONS -------------------------
  // ------------------------------------------------------------

  // Growth rate
  growth() {
    let areaGrowths: any[] = [];
    let totalAreaGrowths: any[] = [];
    let growthRates: number[] = [];
    
    if (this.$store.state.pasture.simulation.growthRateSource === 'Add Pasture Types') {
      let pastureKeys = Object.keys(store.state.pasture!.monthlyPasture[0]).filter(
        (e: any) => e.substr(0, 1) === "p"
      );
      // Area x Growth (Pasture)
      for (let i = 0; i < pastureKeys.length; i++) {
        let arr: any[] = [];
        store.state.pasture!.monthlyPasture.forEach((month: any) => {
          arr.push(
            Math.round(month[pastureKeys[i]].area * month[pastureKeys[i]].growth)
          );
        });
        areaGrowths.push(arr);
      }
      // Area x Growth (Monthly Total)
      for (let j = 1; j < areaGrowths.length; j++) {
        totalAreaGrowths = areaGrowths[0].map((num: any, idx: any) => {
          for (let k = 1; k < pastureKeys.length; k++) {
            return num + areaGrowths[k][idx];
          }
        });
      }
    }

    // Average Growth Rate
    const vm = this
    function getAverageGrowth(month: MonthlyPasture) {
      const growthSource = vm.$store.state.pasture.simulation.growthRateSource
      const index = vm.$store.state.pasture.monthlyPasture.indexOf(month)
      let avgG = 0
      // Combined pasture growths rates
      if (growthSource === 'Add Pasture Types') {
        // ((growth1 * area1) + (growth2 * area2) + ...) / total area
        let pastureColumns:PastureKeys[] = Object.keys(month).filter((e: any) => e.substr(0, 1) === 'p') as PastureKeys[]
        let totalArea:number = 0
        pastureColumns.forEach((p:PastureKeys) => {
            if (month[p] !== undefined) {
                if (month[p].pasture.type !== null) {
                    totalArea += month[p].area
                    avgG += month[p].growth * month[p].area
                }
            }
        })
        avgG = avgG / totalArea
      // Standard growth rates
      } else if (growthSource === 'Standard Average Values') {
        avgG = LOCATIONS[vm.$store.state.pasture.simulation.location - 1].StdPastureGrowth[index]
      } else {
        avgG = vm.$store.state.pasture.monthlyPasture[index].avgGrowth
      }
      if (isNaN(avgG)) {
        return 0
      }
      return avgG
    }
    this.$store.state.pasture.monthlyPasture.forEach((month:MonthlyPasture) => {
      growthRates.push(this.trim(getAverageGrowth(month)))
    });

    let growths = {
      areaGrowths: areaGrowths,
      totalAreaGrowths: totalAreaGrowths,
      growthRates: growthRates
    }

    // TESTS
    // console.log(growths)

    this.common.growth = growths
    return growths
  }

  // Weightings needed to calculate the dmdis (Input Worksheet)
  weighting() {
    const growth = this.common.growth

    // Weightings
    let weightings: any[] = [];
    for (let p = 0; p < growth.areaGrowths.length; p++) {
      weightings.push(
        growth.totalAreaGrowths.map((tag: any, month: any) => {
          return (
            Math.round((growth.areaGrowths[p][month] / tag) * 100) / 100 ||
            1 / (growth.areaGrowths.length * 100)
          );
        })
      );
    }

    // TESTS
    // console.log("Weightings", weightings);

    this.common.weighting = weightings;
    return weightings;
  }

  // Array of average dmdi for each month (Input Worksheet)
  dmdi (this:any) {
    const growth = this.common.growth
    const weighting = this.common.weighting
    const growthSource:GrowthRateSources = this.$store.state.pasture.simulation.growthRateSource
    let dmdis:any[] = Array(24).fill(0)

    if (growthSource === 'Add Pasture Types') {
      // Get Fortnightly DMDIs for each selected pasture
      let dmdiFortnightly:any[] = []
      for (let i = 0; i < store.state.pasture!.simulation.pastures.length; i++) {
        let index = this.types.map((e:any) => e.Pasture).indexOf(store.state.pasture!.simulation.pastures[i].type)
        let pastures = PASTURES.filter((e:any) => e.LocationID === this.types[index].LocationID)
        let activePasture = pastures[pastures.map((e:any) => e.Pasture).indexOf(this.types[index].Pasture)]
        let activePastureDMDIFortnightly = DMDI[this.enterprise][activePasture.ID - 1]
        activePastureDMDIFortnightly = Object.values(activePastureDMDIFortnightly)

        let activePastureDMDI:any[] = []
        for (let j = 0; j < activePastureDMDIFortnightly.length; j++) {
          activePastureDMDI.push((activePastureDMDIFortnightly[j]))
        }
        dmdiFortnightly.push(activePastureDMDI)
      }

      // Multiply pasture dmdi by corresponding weighting
      let results:any[] = []
      dmdiFortnightly.forEach((pasture:any, pIx:number) => {
        results.push([])
        pasture.map((dmdi:any, dIx:number) => {
          results[pIx].push(pasture[dIx] * weighting[pIx][Math.floor((dIx) / 2)])
        })
      })

      // Get combined pasture average dmdi
      results.forEach((pasture:any, ix:number) => {
        for (let i = 0; i < pasture.length; i++) {
          dmdis[mod(this.periods[i] - 1, 24)] += pasture[mod(this.periods[i] - 1, 24)]
        }
      })
    } else {
      // Get standard / user selected dmdi
      let count = 0
      this.$store.state.pasture.monthlyPasture.forEach((pasture:any, pix:number) => {
        for (let i = 1; i <= 2; i++) {
          dmdis[count] = (pasture.avgQuality + 2) / 17
          count += 1
        }
      });
    }

    // Final Enterprise-Specific DMDI Values
    let finalDmdis = dmdis.map((dmdi, period) => {
      if (growthSource === 'User-supplied Average Values' && this.$store.state.pasture.simulation.enterprise === 'Cattle & Sheep') {
        let tabularDmdiCattle = LOCATIONS[this.$store.state.pasture.simulation.location - 1].StdDmdiCattle
        let tabularDmdiSheep = LOCATIONS[this.$store.state.pasture.simulation.location - 1].StdDmdiSheep
        return dmdi + 0.5 * (tabularDmdiCattle[period] - tabularDmdiSheep[period])
      } else if (growthSource === 'Standard Average Values') {
        return (
          this.enterprise === 'cattle'
          ? LOCATIONS[this.$store.state.pasture.simulation.location - 1]['StdDmdiCattle'][period]
          : LOCATIONS[this.$store.state.pasture.simulation.location - 1]['StdDmdiSheep'][period]
        )
      } else {
        return dmdi
      }
    })
    
    // Include supplement values
    let dmdisWithSupplement = Array(24).fill(0)
    for (let period = 1; period <= 24; period++) {
      let dmdi = finalDmdis[period - 1]
      let month = Math.max(1, Math.ceil(period / 2)) - 1
      let growthRate = growth.growthRates[month]
      let supplementAmount = store.state.pasture!.monthlyPasture[month].supplement.amount
      let supplementDmdi = parseFloat(supplementAmount.toString()) > 0 ? store.state.pasture!.monthlyPasture[month].supplement.quality / 16 : dmdi
      dmdisWithSupplement[this.periods.indexOf(mod(period, 24))] = ((dmdi * growthRate + supplementAmount * supplementDmdi) / (growthRate + supplementAmount))
      dmdisWithSupplement = dmdisWithSupplement.map((dws:number) => { return isNaN(dws) ? 0 : this.trim(dws) })
    }

    // TESTS
    // console.log('DMDIs Fortnightly', dmdiFortnightly)
    // console.log('Weightings', weighting)
    // console.log('Results', results)
    // console.log('DMDIs - ' + this.enterprise, finalDmdis)
    // console.log('DMDIs with Supplement - ' + this.enterprise, dmdisWithSupplement)

    this.common.dmdi = dmdisWithSupplement
    return dmdisWithSupplement
  }

  // Starting conception rate - Reference CR (Mating Worksheet)
  referenceCR(joiningPeriod: 1 | 2) {
    const jp = this.getEnterprise.livestock.joinPeriods[joiningPeriod - 1];

    let toDatePeriod = StartDates.indexOf(dayjs(jp.toDate).format("D MMM"));
    let fromDatePeriod = StartDates.indexOf(dayjs(jp.fromDate).format("D MMM"));
    let lengthOfJoining = mod(toDatePeriod - fromDatePeriod, 24);

    let referenceCR =
      1 -
      Math.pow(1 - Math.min(jp.expectation, 0.999), 1 / lengthOfJoining) *
        Math.min(1, this.minMatingIntervalPeriods / lengthOfJoining);

    // TESTS
    // console.log('Length of joining', lengthOfJoining)
    // console.log('Reference CR', referenceCR)

    return referenceCR;
  }

  // Estimated conception rates x period: returns for (jp1, jp2 and total)
  conceptionRate() {
    let overallWeaningRate: number;
    let CR: number;
    let lambsConcieved = { single: new Array(24).fill(0), twins: new Array(24).fill(0), total: new Array(24).fill(0) };
    let survivingRates = { jp1: new Array(24).fill(0), jp2: new Array(24).fill(0) };
    let survivingTotals = { single: new Array(24).fill(0), twins: new Array(24).fill(0) };
    const mortality = {
      singles: 0.1,
      twins: 0.25
    };
    const vm = this;
    function getConceptionRateForJoiningPeriod(
      referenceCR: Function,
      jpNum: number
    ) {
      let FR: any[] = [];
      let numConceived: any[] = [];

      for (let iteration = 0; iteration < 4; iteration++) {
        const jp = store.state[vm.enterprise].livestock.joinPeriods[jpNum];
        let toDatePeriod = StartDates.indexOf(dayjs(jp.toDate).format("D MMM"));
        let fromDatePeriod = StartDates.indexOf(dayjs(jp.fromDate).format("D MMM"));
        let lengthOfJoining = mod(toDatePeriod - fromDatePeriod, 24);
        let numWeaned: any[] = [];

        // Initial Iteration
        if (iteration === 0) {
          CR = referenceCR(jpNum + 1);
          let twinningRate = Math.max(
            0,
            Math.min(
              1,
              vm.param.TWINSA + vm.param.TWINSB * CR * ((24 * 17) / 365)
            )
          );
          CR = vm.enterprise === "sheep" ? (CR = CR / (1 + twinningRate)) : CR;
        } else {
          CR = (CR * jp.expectation) / overallWeaningRate;
        }
        // console.log('Reference CR', CR)

        // MATRIX (Mating)
        let matrix: any[] = [];
        // P(>=1)
        let periods: any[] = new Array(24);
        for (let k = 0; k < 24; k++) {
          let row: any[] = new Array(24);
          for (let j = 0; j < 24; j++) {
            row[j] =
              j === k
                ? 1
                : 24 + ((k - j) % 24) < vm.minMatingIntervalPeriods
                ? CR
                : 0;
            if (k < lengthOfJoining) {
              periods[k] = CR;
              if (j < k) {
                row[j] = CR;
              }
            } else {
              row[j] = j === k ? 1 : 0;
            }
          }
          row = Array.from(row, (item) => item || 0);
          matrix.push(row);
        }
        periods = Array.from(periods, (item) => item || 0);
        // console.log('Matrix', matrix)
        // console.log('P(>=1)', periods)
        // console.log(multiply(inv(matrix), p))

        // TW
        let tw =
          vm.enterprise === "sheep"
            ? Math.max(
                0,
                Math.min(1, vm.param.TWINSA + vm.param.TWINSB * periods[0])
              )
            : 0;
        // ('TW', TW)

        // FR
        FR = multiply(inv(matrix), periods);
        for (let i = 0; i < (dayjs(jp.fromDate).month() * 2); i++) {
          FR.splice(0, 0, FR.pop());
        }
        // console.log('FR', FR)

        // # Conceived
        numConceived = FR.map(fr => fr * (1 + tw))
        // console.log('# Convceived', numConceived)

        // # Weaned, overallWeaningRate
        if (vm.enterprise === "cattle") {
          overallWeaningRate = numConceived.reduce(
            (prev: number, cur: number) => prev + cur
          );
        } else {
          for (let i = 0; i < 24; i++) {
            numWeaned[i] =
              FR[i] *
              ((1 - mortality.singles) * (1 - tw) +
                2 * tw * (1 - mortality.twins));
          }
          overallWeaningRate = numWeaned.reduce(
            (prev: number, cur: number) => prev + cur
          );
        }
        // console.log('# Weaned', numWeaned)
        // console.log('Overall Weaning Rate', overallWeaningRate)

        // Estimated Conception Rates x Period
        // Cattle (1) | Sheep (1)
        const percentage = parseFloat(jp.percentage.toString());
        let conceptionRatesPerPeriod = FR.map((c: number) => {
          if (vm.enterprise === "cattle") {
            return c * (percentage / 100)
          }
          if (vm.enterprise === "sheep") {
            return c * (percentage / 100) * (1 - tw)
          }
        });
        // console.log('Estimated Conception Rates x Period', conceptionRatesPerPeriod)

        if (iteration === 3) {
          if (vm.enterprise === "sheep") {
            let sheep1 = conceptionRatesPerPeriod
            let sheep2 = FR.map((c: number) => c * (percentage / 100) * tw)

            // console.log('sheep (1)', sheep1)
            // console.log('sheep (2)', sheep2)

            // Lambs Conceived

            lambsConcieved.single = lambsConcieved.single.map((lcs: any, ix: number) => {
              return lcs + sheep1[ix]
            })
            lambsConcieved.twins = lambsConcieved.twins.map((lct: any, ix: number) => {
              return lct + sheep2[ix]
            })
            lambsConcieved.total = lambsConcieved.single.map((lcs: any, ix: number) => {
              return lcs + 2 * lambsConcieved.twins[ix]
            })

            // Estimated (Surviving) Lambing / Calving Rates x Period

            sheep1 = sheep1.map((s:any) => s * (1 - mortality.singles))
            sheep2 = sheep2.map((s:any) => s * (1 - mortality.twins))

            // console.log('sheep (1)', sheep1)
            // console.log('sheep (2)', sheep2)

            survivingTotals.single = survivingTotals.single.map((st: any, ix: number) => {
              return st + sheep1[ix]
            })
            survivingTotals.twins = survivingTotals.twins.map((st: any, ix: number) => {
              return st + sheep2[ix]
            })

            if (jpNum === 0) {
              survivingRates.jp1 = survivingRates.jp1.map((sr: any, ix: number) => {
                return sr + sheep1[ix] + 2 * sheep2[ix]
              })
            } else {
              survivingRates.jp2 = survivingRates.jp2.map((sr: any, ix: number) => {
                return sr + sheep1[ix] + 2 * sheep2[ix]
              })
            }
          }

          return conceptionRatesPerPeriod;
        }
      }
    }

    let CRJP1: any = getConceptionRateForJoiningPeriod(this.referenceCR, 0);
    let CRJP2: any = getConceptionRateForJoiningPeriod(this.referenceCR, 1);

    // Calves Concieved
    let calvesConceived = CRJP1.map((cr: number, index: number) => cr + CRJP2[index]);

    let CRTOTAL = (vm.enterprise === "cattle") ? calvesConceived : lambsConcieved.total

    let conceptionRate = {
      lambs: {
        survivingTotals: survivingTotals,
        survivingRates: survivingRates
      },
      jp1: CRJP1.map((v:number) => this.trim(v)),
      jp2: CRJP2.map((v:number) => this.trim(v)),
      total: CRTOTAL.map((v:number) => this.trim(v)),
    };

    // TESTS
    // console.log('Conception Rate', conceptionRate)

    this.common.conceptionRate = conceptionRate;
    return conceptionRate;
  }

  // Average day of year of birth (0-365)
  averageDOYofBirth() {
    const startingDOY = dayjs(store.state.pasture!.simulation.date).dayOfYear() + 1;
    let ageNowArr: number[] = [];
    let conceivedArr: any[] = this.cleanSource(
      this.common.conceptionRate.total
    );
    
    for (let i = 0; i < 24; i++) {
      let periodMidpointDOY:number = dayjs(MidpointDates[i]).dayOfYear();
      let ageNow = startingDOY - periodMidpointDOY - this.gestationLength + 365;
      ageNowArr.push(ageNow);
    }
    ageNowArr = ageNowArr.map((an, an_ix) => {
      if (conceivedArr[an_ix] > 0 && conceivedArr[mod(an_ix - 1, 24)]) {
        return (
          ageNowArr[mod(an_ix - 1, 24)] -
          (dayjs(MidpointDates[an_ix]).dayOfYear() -
          (dayjs(MidpointDates[mod(an_ix - 1, 24)]).dayOfYear() - (an_ix === 0 ? 365 : 0)))
        )
      } else {
        return an
      }
    })

    let averageAgeNow = 0;
    let conceivedXAgeNow = conceivedArr.map((c: number, index: number) => {
      return c * ageNowArr[index]
    });
    if (conceivedArr.reduce((a, b) => a + b, 0) === 0) {
      averageAgeNow = ageNowArr[this.periods[0]]
    } else {
      averageAgeNow = (
        1 + mod((conceivedXAgeNow.reduce((a, b) => a + b, 0) / conceivedArr.reduce((a, b) => a + b, 0) - 1), 365)
      );
    }

    let averageDOYofBirth = mod(startingDOY - averageAgeNow, 365) || 0;

    // TESTS
    // console.log('Starting day of year', startingDOY)
    // console.log((this.enterprise === 'cattle' ? 'Calves' : 'Lambs') + ' conceived', conceivedArr)
    // console.log('Age Now Arr', ageNowArr)
    // console.log('Average Age Now', averageAgeNow)
    // console.log('Average DOY of Birth', averageDOYofBirth)

    this.common.averageDOYofBirth = averageDOYofBirth;
    return averageDOYofBirth;
  }

  // Start Ages (day | months)
  startAges() {
    const years: any = {
      "Cows (>3 years)": 6,
      "Cows (2-3 years)": 2,
      "Heifers (1-2 years)": 1,
      "Steers (1-2 years)": 1,
      "Weaned young heifers": 0,
      "Weaned young steers": 0,
      "Calves weaned this year": 0,
      "Ewes (>2 years)": 4,
      "Ewes (1-2 years)": 1,
      "Wethers (1-2 years)": 1,
      "Weaned young ewes": 0,
      "Weaned young wethers": 0,
      "Lambs weaned this year": 0,
    };

    const sd = dayjs(store.state.pasture!.simulation.date).format('D MMM');
    const dy = dayjs(cleanDate(sd, 'D MMM'), 'D MMM').dayOfYear();
    const { averageDOYofBirth } = this.common;

    let startAgeDays: any[] = [];
    this.stocks.forEach((stock) => {
      if (stock.type === "Breeding") {
        startAgeDays.push(
          (365 * years[stock.class] + mod(dy - averageDOYofBirth, 365))
        );
      } else {
        if (stock.startAge && stock.startAge > 0) {
          startAgeDays.push((stock.startAge * 365) / 12);
        } else if (stock.purchaseAge && stock.purchaseAge > 0) {
          let ageAtPurchase = ((stock.purchaseAge * 365) / 12) / (365 / 12)
          let purchasePeriod = StartDates.indexOf(dayjs(stock.purchaseDate).format("D MMM")) + 1
          let ageAtStart = ageAtPurchase > 0 ? ageAtPurchase - mod(purchasePeriod - this.periods[0], 24) / 2 : 24
          startAgeDays.push(ageAtStart * (365 / 12));
        } else {
          startAgeDays.push(0);
        }
      }
    });

    let startAgeMonths = startAgeDays.map((sad: any) => {
      return sad / (365 / 12);
    });

    let startAges = {
      days: startAgeDays.map((v:number) => this.trim(v)),
      months: startAgeMonths.map((v:number) => this.trim(v)),
    };

    // TESTS
    // console.log("Start Ages (days): ", startAges.days);
    // console.log("Start Ages (months): ", startAges.months);

    this.common.startAges = startAges;
    return startAges;
  }

  // Ages at midpoint
  agesAtMidpoint() {
    const startAges = this.common.startAges.days;

    let agesAtMidpoint: any[] = [];
    this.stocks.forEach((stock, stockIndex: number) => {
      if (
        stock.purchaseNumber > 0 ||
        stock.saleNumber > 0 ||
        (stock.startNumber && stock.startNumber > 0)
      ) {
        let stockAges: any[] = [];
        for (let period = 0; period < 24; period++) {
          let ixPrev = mod(this.periods[mod(period - 1, 24)] - 1, 24);
          let ixCurr = mod(this.periods[mod(period - 1, 24)], 24);
          if (period === 0) {
            stockAges.push(startAges[stockIndex] + 0.5 * PeriodLengths[ixCurr]);
          } else {
            stockAges.push(
              stockAges[period - 1] + 0.5 * (PeriodLengths[ixPrev] + PeriodLengths[ixCurr])
            );
          }
        }
        agesAtMidpoint.push(stockAges.map((v:number) => this.trim(v)));
      } else {
        agesAtMidpoint.push([]);
      }
    });

    // TESTS
    // console.log('Ages at midpoint: ', agesAtMidpoint)

    this.common.agesAtMidpoint = agesAtMidpoint;
    return agesAtMidpoint;
  }

  // SRW Scalar needed for Liveweights and animalSRW
  srwScalar(this: any, stock: Stock) {
    let srwScalar: number = 1;
    if (stock.type.toLowerCase() === "trading") {
      switch (stock.class.toLowerCase()) {
        case "dry cows or heifers":
        case "dry ewes":
        case "weaned young heifers":
        case "weaned young ewes":
          srwScalar = 1;
          break;
        case "steers":
        case "wethers":
        case "weaned young steers":
        case "weaned young wethers":
          srwScalar = 1.2;
          break;
        case "bulls":
        case "rams":
          srwScalar = 1.4;
          break;
        default:
          srwScalar = 1;
      }
    }
    return srwScalar;
  }

  // Animal SRW (kg)
  animalSRW() {
    let animalSRWs: any[] = [];
    this.stocks.forEach((stock) => {
      if (
        stock.purchaseNumber > 0 ||
        stock.saleNumber > 0 ||
        (stock.startNumber && stock.startNumber > 0)
      ) {
        const stockClass = stock.class.toLowerCase();
        const stockType = stock.type.toLowerCase();
        let isFemale = 0;
        let srw = 0;

        isFemale =
          stockClass.includes("cows") ||
          stockClass.includes("heifers") ||
          stockClass.includes("ewes")
            ? 1
            : 0;
        srw = (1.2 - 0.2 * isFemale) * this.livestockWeight;

        if (stockType === "trading") {
          srw = this.livestockWeight * this.srwScalar(stock);
        }

        let animalSRW: any[] = [];
        for (let i = 0; i < 24; i++) {
          animalSRW.push(srw);
        }

        animalSRWs.push(animalSRW);
        // console.log(stockClass + ' - ' + stockType, animalSRW)
      } else {
        animalSRWs.push(new Array(24).fill(0));
      }
    });

    // TEST
    // console.log('Animal SRW', animalSRWs)

    this.common.animalSRW = animalSRWs;
    return animalSRWs;
  }

  // M/D(solid)
  mdSolid() {
    const dmdi = this.common.dmdi;

    let mdSolid: number[] = [];
    for (let period = 0; period < 24; period++) {
      mdSolid.push(this.trim(17 * dmdi[period] - 2));
    }

    this.common.mdSolid = mdSolid;
    return mdSolid;
  }

  // Pasture dW/N
  pastureDwn() {
    // Get the dW/N for the given pastures
    let plocations: any[] = PASTURES.filter(
      (pasture: any) =>
        pasture.LocationID === store.state.pasture!.simulation.location
    );
    let weightings: number[] = [];
    let dwns: any[] = [];
    plocations.map((p: any) => {
      let dwnPeriod: number[] = [];
      for (let i = 1; i <= 24; i++) {
        dwnPeriod.push(this.trim(DWN[this.enterprise][i][PASTURES.indexOf(p)]));
      }
      dwns.push(dwnPeriod);
      weightings.push(PASTURES[PASTURES.indexOf(p)].Weight);
    });

    // Get the dW/N for given location (Lookup tables: dW/N - Cattle | dW/N - Sheep)
    let dwnSumArr: any[] = [];
    for (let i = 0; i < 24; i++) {
      let dwnSum: number = 0;
      let weightingsSum: number = 0;
      dwns.forEach((dwn, dwnIX) => {
        dwnSum += dwn[i] * weightings[dwnIX];
        weightingsSum += weightings[dwnIX];
      });
      dwnSum = dwnSum / weightingsSum;
      dwnSumArr.push(this.trim(dwnSum));
    }

    let dwnResults = {
      dwns: dwns,
      dwnSummary: dwnSumArr,
    };

    // TESTS
    // console.log('Pasture Weighting', weightings)
    // console.log('Pasture dW/N - ' + this.enterprise, dwns)
    // console.log('dW/N Sums - ' + this.enterprise, dwnSumArr)

    this.common.pastureDwn = dwnResults;
    return dwnResults;
  }

  // Default weights for age
  defaultWeightForAge() {
    const averageDOYofBirth = this.common.averageDOYofBirth;
    const dwnSummary = this.common.pastureDwn.dwnSummary;

    // Default weights for age, including LW change pattern (Numbers Etc)
    let defaultWeightForAges: any[] = [];
    let startingPeriod: number = 0;
    let dayOfYear: number = 0;
    while (averageDOYofBirth > dayOfYear) {
      dayOfYear += PeriodLengths[startingPeriod];
      startingPeriod++;
    }
    for (let i = 0; i < 240; i++) {
      let period: number = (startingPeriod + i) % 24;
      period = period === 0 ? 24 : period;
      let wsrw: number =
        i === 0
          ? this.param.BWN
          : defaultWeightForAges[i - 1].wsrw +
            defaultWeightForAges[i - 1].dwsrw * (365 / 24);
      let dwsrw: number =
        this.curvature * (1 - wsrw) + dwnSummary[period - 1] * wsrw;
      defaultWeightForAges.push({
        age: i / 2,
        period: period,
        dwsrw: this.trim(dwsrw),
        wsrw: this.trim(wsrw),
        weightForAge: {
          female: this.trim(this.livestockWeight * wsrw),
          castrate: this.trim(this.livestockWeight * 1.2 * wsrw), // 1.2 srwScalar for steers & wethers
          male: this.trim(this.livestockWeight * 1.4 * wsrw), // 1.4 srwScalar for bulls & rams
        },
      });
    }

    // TESTS
    // console.log('Default weights for age, including LW change pattern', defaultWeightForAges)

    this.common.defaultWeightForAge = defaultWeightForAges;
    return defaultWeightForAges;
  }

  // Default dW (kg/d) & Default dW(kg/period)
  defaultDw() {
    const agesAtMidpoint = this.common.agesAtMidpoint;
    const maxNormalWeight = this.common.maxNormalWeight;
    const dwnSummary = this.common.pastureDwn.dwnSummary;
    const animalSRW = this.common.animalSRW;

    let defaultDWPerDays: any[] = [];
    let defaultDWPeriods: any[] = [];
    this.stocks.forEach((stock, stockIX: number) => {
      let ddwday: any[] = [];
      let ddwperiod: any[] = [];
      if (agesAtMidpoint[stockIX]) {
        for (let i = 0; i < 24; i++) {
          let periodIX =
            mod(this.periods[i], 24) === 0 ? 23 : mod(this.periods[i], 24) - 1;
          ddwday.push(
            this.trim(
              this.curvature *
                (animalSRW[stockIX][i] - maxNormalWeight[stockIX][i]) +
                dwnSummary[periodIX] * maxNormalWeight[stockIX][i]
            )
          );
          ddwperiod.push(this.trim(ddwday[i] * PeriodLengths[periodIX]));
        }
        defaultDWPerDays.push(ddwday);
        defaultDWPeriods.push(ddwperiod);
      }
    });

    let defaultDws = {
      kgDay: defaultDWPerDays,
      kgPeriod: defaultDWPeriods,
    };

    // TESTS
    // console.log('Default dW (kg/d)', defaultDWPerDays)
    // console.log('Default dW (kg/period)', defaultDWPeriods)
    // console.log('Default DWs', defaultDws)

    this.common.defaultDw = defaultDws;
    return defaultDws;
  }

  // Max normal weights (kg) - N(max)
  maxNormalWeight() {
    const animalSRW = this.common.animalSRW;
    const agesAtMidpoint = this.common.agesAtMidpoint;

    let maxNormalWeights: any[] = [];
    this.stocks.forEach((stock, stockIndex: number) => {
      if (
        stock.purchaseNumber > 0 ||
        stock.saleNumber > 0 ||
        (stock.startNumber && stock.startNumber > 0)
      ) {
        let mnWeights: number[] = [];
        for (let period = 0; period < 24; period++) {
          mnWeights.push(
            this.trim(
            animalSRW[stockIndex][period] *
              (this.param.BWN +
                (1 - this.param.BWN) *
                  (1 -
                    Math.exp(
                      -this.curvature * agesAtMidpoint[stockIndex][period]
                    )))
            )
          );
        }
        maxNormalWeights.push(mnWeights);
      } else {
        maxNormalWeights.push(new Array(24).fill(0));
      }
    });

    // TEST
    // console.log('Max Normal Weight', maxNormalWeights)

    this.common.maxNormalWeight = maxNormalWeights;
    return maxNormalWeights;
  }

  // Live weights (kg)
  liveWeight() {
    const defaultWeightForAge = this.common.defaultWeightForAge;
    const agesAtMidpoint = this.common.agesAtMidpoint;
    const defaultDwkgPeriod = this.common.defaultDw.kgPeriod;
    const maxNormalWeight = this.common.maxNormalWeight;

    // Default LW (kg)
    let liveWeights: any[] = [];
    this.stocks.forEach((stock, stockIndex: number) => {
      let stockLiveWeight: number[] = [];
      for (let period = 0; period < 24; period++) {
        defaultWeightForAge.map((sw: any) => {
          if (
            agesAtMidpoint[stockIndex] &&
            sw.age === Math.floor((agesAtMidpoint[stockIndex][period] / (365 / 12)) / 0.5) * 0.5
          ) {
            if (period === 0) {
              let weight: number = 0;
              // Use user set start weight
              if (stock.startWeight && stock.startWeight > 0) {
                weight = stock.startWeight;
                // Use default start weight
              } else {
                // Female
                weight = sw.weightForAge.female;
                // Castrated
                if (
                  stock.class.toLowerCase().includes("steers") ||
                  stock.class.toLowerCase().includes("wethers")
                ) {
                  weight = sw.weightForAge.castrate;
                }
                // Male
                if (
                  stock.class.toLowerCase().includes("bulls") ||
                  stock.class.toLowerCase().includes("rams")
                ) {
                  weight = sw.weightForAge.male;
                }
              }
              // Return live weight for first period
              if (stock.type.toLowerCase() === "trading") {
                stockLiveWeight.push(
                  agesAtMidpoint[stockIndex][period] < 0
                    ? maxNormalWeight[stockIndex][period]
                    : weight + 0.5 * defaultDwkgPeriod[stockIndex][period]
                );
              } else {
                stockLiveWeight.push(
                  weight + 0.5 * defaultDwkgPeriod[stockIndex][period]
                );
              }
            } else {
              stockLiveWeight.push(
                this.trim(
                  stockLiveWeight[period - 1] +
                    0.5 *
                      (defaultDwkgPeriod[stockIndex][period - 1] +
                        defaultDwkgPeriod[stockIndex][period])
                )
              );
            }
          }
        });
      }
      liveWeights.push(stockLiveWeight);
    });

    // TESTS
    // console.log("Liveweights", liveWeights);

    this.common.liveWeight = liveWeights.map((i) => {
      if (i.length === 0) return new Array(24).fill(0);
      return i;
    });
    return liveWeights;
  }

  // Previous Max Weights (kg)
  previousMaxWeight() {
    let liveWeights = this.common.liveWeight;
    let previousMaxWeightsArr: any[] = [];

    this.stocks.forEach((stock, stockIX: number) => {
      if (
        stock.purchaseNumber > 0 ||
        stock.saleNumber > 0 ||
        (stock.startNumber && stock.startNumber > 0)
      ) {
        let isMature: boolean =
          stock.class === "Cows (>3 years)" ||
          stock.class === "Ewes (>2 years)" ||
          stock.startAge > 36;
        let weights: number[] = [];
        for (let period = 0; period < 24; period++) {
          if (period === 0) {
            weights.push(
              isMature
                ? this.common.animalSRW[stockIX][period]
                : liveWeights[stockIX][period]
            );
          } else {
            weights.push(
              this.trim(Math.max(liveWeights[stockIX][period], weights[period - 1]))
            );
          }
        }
        previousMaxWeightsArr.push(weights);
      } else {
        previousMaxWeightsArr.push(new Array(24).fill(0));
      }
    });

    // TESTS
    // console.log('Previous Max Weights (kg)', previousMaxWeightsArr)

    this.common.previousMaxWeight = previousMaxWeightsArr;
    return previousMaxWeightsArr;
  }

  // Weight Change (kg/d)
  weightChange() {
    const defaultDwKgDay = this.common.defaultDw.kgDay;

    let weightChangeArrs: any[] = [];
    this.stocks.forEach((stock, stockIX: number) => {
      let weightChange: any[] = [];
      for (let i = 0; i < 24; i++) {
        weightChange.push(defaultDwKgDay[stockIX][i]);
      }
      weightChangeArrs.push(weightChange);
    });

    // TESTS
    // console.log('Weight Change', weightChangeArrs)

    this.common.weightChange = weightChangeArrs;
    return weightChangeArrs;
  }

  // Mean conceptus weight (kg)
  meanConceptusWeight() {
    // Conceptus Weights
    const BW = this.livestockWeight * this.param.BWN;

    const conceptusWeights: number[] = [];
    for (let i = 0; i < 24; i++) {
      let foetalAge = Math.round((365 * this.periods[i]) / 24);
      let conceptusWeight: number =
        this.param.CP5 *
        BW *
        Math.exp(
          this.param.CP6 *
            (1 - Math.exp(this.param.CP7 * (1 - foetalAge / this.param.CP1)))
        );
      this.periods[i] < this.gestationPeriods
        ? conceptusWeights.push(conceptusWeight)
        : conceptusWeights.push(0);
    }

    let meanConceptusWeights:any[] = []
    this.stocks.forEach((stock, stockIndex: number) => {
      // Reproductive Cycle
      let reproductiveCycle = this.cleanSource(this.common.conceptionRate.total).reverse()
      if (!this.getEnterprise.livestock.joinOption && stock.class.includes('(1-2 years)')) {
        reproductiveCycle = Array.from(Array(24), () => 0)
      }
      // console.log('Reproductive Cycle', reproductiveCycle)

      // meanConceptusWeights
      let meanConceptusWeight: number[] = [];
      for (let i = 0; i < 24; i++) {
        // Reproductive cycle * conceptusWeights
        let weight = conceptusWeights.reduce((r, a, i) => {
          return this.trim(r + a * reproductiveCycle[i]);
        }, 0);
        meanConceptusWeight.push(weight);
        reproductiveCycle.splice(0, 0, reproductiveCycle.pop());
      }

      meanConceptusWeights.push(this.producesOffspring.includes(stock.class) ? meanConceptusWeight : Array.from(Array(24), () => 0))
    })

    // TESTS
    // console.log('Conceptus Weights', conceptusWeights)
    // console.log('Mean Concuptus Weights', meanConceptusWeights)

    this.common.meanConceptusWeight = meanConceptusWeights;
    return meanConceptusWeights;
  }

  // Base weight, W
  baseWeight(stockIndex: number) {
    const liveWeight = this.common.liveWeight[stockIndex];
    const meanConceptusWeight = this.common.meanConceptusWeight[stockIndex];

    let baseWeights: any[] = [];
    for (let period = 0; period < 24; period++) {
      baseWeights.push(liveWeight[period] - meanConceptusWeight[period]);
    }

    // TESTS
    // console.log('Base weight, W', baseWeights)

    return baseWeights;
  }

  // Normal weight (kg)
  normalWeight() {
    let meanConceptusWeights = this.common.meanConceptusWeight;
    let maxNormalWeights = this.common.maxNormalWeight;
    let previousMaxWeights = this.common.previousMaxWeight;

    let normalWeights: any[] = [];
    this.stocks.forEach((stock, stockIndex: number) => {
      if (
        stock.purchaseNumber > 0 ||
        stock.saleNumber > 0 ||
        (stock.startNumber && stock.startNumber > 0)
      ) {
        let nWeights: number[] = [];
        for (let period = 0; period < 24; period++) {
          if (
            previousMaxWeights[stockIndex][period] -
              meanConceptusWeights[stockIndex][period] >
            maxNormalWeights[stockIndex][period]
          ) {
            nWeights.push(maxNormalWeights[stockIndex][period]);
          } else {
            nWeights.push(
              this.trim(
                0.6 *
                  (previousMaxWeights[stockIndex][period] -
                    meanConceptusWeights[stockIndex][period]) +
                  0.4 * maxNormalWeights[stockIndex][period]
              )
            );
          }
        }
        normalWeights.push(nWeights);
      } else {
        normalWeights.push(new Array(24).fill(0));
      }
    });

    // TESTS
    // console.log('Normal Weights', normalWeights)

    this.common.normalWeight = normalWeights;
    return normalWeights;
  }

  // Z
  Z(stockIndex: number) {
    const normalWeights = this.common.normalWeight[stockIndex];
    const animalSRWs = this.common.animalSRW[stockIndex];

    let Zs: any[] = [];
    for (let period = 0; period < 24; period++) {
      Zs.push(normalWeights[period] / Math.max(animalSRWs[period], 1));
    }

    // TEST
    // console.log('Z', Zs)
    // debugger;

    this.common.Z = Zs;
    return Zs;
  }

  // BC
  BC(stockIndex: number) {
    const normalWeights = this.common.normalWeight[stockIndex];
    const baseWeights = this.baseWeight(stockIndex);

    let BCs: any[] = [];
    for (let period = 0; period < 24; period++) {
      BCs.push(baseWeights[period] / Math.max(1, normalWeights[period]));
    }

    // TEST
    // console.log("BC", BCs);

    return BCs;
  }

  // NE(metab) (MJ/d)
  neMetab() {
    const normalWeights = this.common.normalWeight;
    const agesAtMidpoint = this.common.agesAtMidpoint;

    let neMetabs: any[] = [];
    this.stocks.forEach((stock, index: number) => {
      if (
        stock.purchaseNumber > 0 ||
        stock.saleNumber > 0 ||
        (stock.startNumber && stock.startNumber > 0)
      ) {
        let metabs: number[] = [];
        for (let i = 0; i < 24; i++) {
          metabs.push(
            this.trim(
              this.param.CM2 *
                Math.pow(normalWeights[index][i], 0.75) *
                Math.max(0.84, Math.exp(-0.00008 * agesAtMidpoint[index][i]))
            )
          );
        }
        neMetabs.push(metabs);
      } else {
        neMetabs.push(new Array(24).fill(0));
      }
    });

    // TESTS
    // console.log('NE (metab)', neMetabs)
    this.common.neMetab = neMetabs;
    return neMetabs;
  }

  // ME(metab + graze) (MJ/d)
  meMetabGraze() {
    let liveWeights = this.common.liveWeight;
    let dmdis = this.common.dmdi;
    let neGrazeLWs = dmdis.map((dmdi: number) => 0.054 - 0.049 * dmdi);
    let kms = dmdis.map((dmdi: number) => 0.5 + 0.02 * (17 * dmdi - 2));
    let neMetabs = this.common.neMetab;

    let meMetabGrazes: any[] = [];
    this.stocks.forEach((stock, index: number) => {
      if (
        stock.purchaseNumber > 0 ||
        stock.saleNumber > 0 ||
        (stock.startNumber && stock.startNumber > 0)
      ) {
        let metabGrazes: number[] = [];
        for (let i = 0; i < 24; i++) {
          metabGrazes.push(
            this.trim(
              (neMetabs[index][i] + neGrazeLWs[i] * liveWeights[index][i]) /
                kms[i]
            )
          );
        }
        meMetabGrazes.push(metabGrazes);
      } else {
        meMetabGrazes.push(new Array(24).fill(0));
      }
    });

    // TESTS
    // console.log('ME (metab + graze)', meMetabGrazes)

    this.common.meMetabGraze = meMetabGrazes;
    return meMetabGrazes;
  }

  // Pregnancy Mean ME(n) (MJ/d)
  pregnancy() {
    const BW = this.livestockWeight * this.param.BWN;
    const KC = 0.133;

    let stockMEs:any[] = []
    let stockMeanMEs:any[] = []
    this.stocks.forEach((stock, stockIndex: number) => {
      // Reproductive Cycle
      let reproductiveCycle = this.cleanSource(this.common.conceptionRate.total).reverse()
      if (!this.getEnterprise.livestock.joinOption && stock.class.includes('(1-2 years)')) {
        reproductiveCycle = Array.from(Array(24), () => 0)
      }
      // console.log('Reproductive Cycle', reproductiveCycle)

      // NE(c)
      let NEs: number[] = [];
      for (let i = 1; i <= 24; i++) {
        let foetalAge =
          (i * 365) / 24 < this.gestationLength ? Math.round((365 * i) / 24) : 0;
        let NE: number =
          foetalAge > 0
            ? this.param.CP8 *
              (this.param.CP5 * BW) *
              (((this.param.CP9 * this.param.CP10) / this.param.CP1) *
                Math.exp(
                  this.param.CP10 * (1 - foetalAge / this.param.CP1) +
                    this.param.CP9 *
                      (1 -
                        Math.exp(
                          this.param.CP10 * (1 - foetalAge / this.param.CP1)
                        ))
                ))
            : 0;
        i < this.gestationPeriods ? NEs.push(NE) : NEs.push(0);
      }

      // ME(c)
      const MEs = NEs.map((NE: any) => this.trim(NE / KC));
      stockMEs.push(MEs)

      // Mean ME(c)
      let meanMEs: number[] = [];
      for (let i = 0; i < 24; i++) {
        // Reproductive cycle * ME(c)
        let meanME = MEs.reduce((r, a, i) => {
          return r + a * reproductiveCycle[i];
        }, 0);
        meanMEs.push(meanME);
        reproductiveCycle.splice(0, 0, reproductiveCycle.pop());
      }
      meanMEs = meanMEs.map((mme: any, index: number) => {
        return this.trim(meanMEs[mod(this.periods[index] - 1, 24)]);
      });
      stockMeanMEs.push(meanMEs)

      // TESTS
      // console.log('NE(c)', NEs)
      // console.log('ME(c)', MEs)
      // console.log('Mean ME(c)', meanMEs)
    })

    let pregnancy = {
      raw: stockMEs,
      mean: stockMeanMEs,
    };

    this.common.pregnancy = pregnancy;
    return pregnancy;
  }

  // Wool Growth
  woolGrowth() {
    const agesAtMidpoint = this.common.agesAtMidpoint;

    // alpha(w) & beta(w)
    let alphaW: any[] = [];
    let betaW: any[] = [];
    this.stocks.forEach((s: any, stockIndex: number) => {
      let aW: number[] = [];
      let bW: number[] = [];
      for (let period = 0; period < 24; period++) {
        aW.push(
          this.trim(
            this.param.CWA *
              (0.25 +
                0.75 *
                  (1 - Math.exp(-0.025 * agesAtMidpoint[stockIndex][period]))) *
              (1 + this.param.CW6 * (this.daylength[period] - 12)) || 0
          )
        );
        bW.push(
          this.trim(
            this.param.CWB * this.Z(stockIndex)[period] || 0
          )
        );
      }
      alphaW.push(aW);
      betaW.push(bW);
    });

    let woolGrowth = {
      alpha: alphaW,
      beta: betaW,
    };

    this.common.woolGrowth = woolGrowth;
    return woolGrowth;
  }

  // Lactation k(l)
  lactation() {
    const mdSolid = this.common.mdSolid;

    let lactation: number[] = [];
    for (let period = 0; period < 24; period++) {
      lactation.push(this.trim(0.4 + 0.02 * mdSolid[period]));
    }

    this.common.lactation = lactation;
    return lactation;
  }

  // Suckling join periods
  sucklingJoinPeriod(lessThan2YearsOld?: boolean) {
    const stock = this.getEnterprise.stock;
    const livestock = this.getEnterprise.livestock;

    // Assigns the suckling values for each join period
    let sucklingJoinPeriods: any[] = [];
    for (let jpNum = 0; jpNum < 2; jpNum++) {
      // Sell On - calves / lambs weaned this year sale date period
      let weanedSaleDate: string = stock.filter((s: Stock) => s.class.includes("weaned this year"))[0].saleDate;
      let sellOn = StartDates.indexOf(dayjs(weanedSaleDate).format("D MMM")) + 1;
      // console.log('Sell On', sellOn)

      // Wean On
      let weanOn = StartDates.indexOf(dayjs(livestock.joinPeriods[jpNum].weanDate).format("D MMM")) + 1;
      // console.log('weanOn', weanOn)

      // Weaned at Sale
      // let weanedAtSale: number = mod(sellOn - weanOn, 24);
      // console.log('weanedAtSale', weanedAtSale)

      // Calves / Cow or Lambs / Ewe (Blue Row)
      let periodOfMating: any[] = [];
      let periodOfBirth: any[] = [];
      let youngPerStock: any[] = this.cleanSource(
        this.enterprise === 'cattle'
        ? this.common.conceptionRate["jp" + (jpNum + 1)]
        : this.common.conceptionRate.lambs.survivingRates["jp" + (jpNum + 1)]
      );
      for (let i = 24; i >= 0; i--) {
        let pob = this.periods[0] - i;
        periodOfBirth.push(pob);
        periodOfMating.push(pob - this.gestationPeriods);
      }
      youngPerStock = youngPerStock.map((pas: any, index: number) => {
        let ypsIndex = mod(periodOfMating[index], 24) - 1;
        ypsIndex = ypsIndex !== -1 ? ypsIndex : 23;
        return youngPerStock[ypsIndex];
      });
      // console.log('Period of mating', periodOfMating)
      //console.log('Young Per Stock (blue):', youngPerStock)

      // Young present at start (Red Column)
      let youngPresentAtStart: any[] = this.cleanSource(youngPerStock);
      youngPresentAtStart.forEach((c: number, cIndex: number) => {
        let weanedAtStart: boolean = false;
        weanedAtStart = periodOfBirth[cIndex] < weanOn - (weanOn < this.periods[0] ? 0 : 24);
        // console.log('Weaned at start ' + cIndex, weanedAtStart)
        youngPresentAtStart[cIndex] = weanOn === this.periods[0] || weanedAtStart === true ? 0 : c;
        // Handle none present at start exception for (1-2 years)
        if (lessThan2YearsOld) {
          youngPresentAtStart[cIndex] = 0;
        }
      });
      youngPresentAtStart.reverse();
      // console.log('Young Present At Start (red)', youngPresentAtStart)

      // Generate Suckling Rows
      let sucklingArr: any[] = [];
      for (let calfAge = 0; calfAge < 24; calfAge++) {
        if (calfAge === 0) {
          youngPerStock.unshift(youngPerStock.pop());
          sucklingArr.push(youngPerStock);
        } else {
          let arr: any[] = [];
          for (let period = 0; period < 24; period++) {
            if (period === 0) {
              arr.push(youngPresentAtStart[calfAge]);
            } else {
              if (this.periods[period] === weanOn) {
                arr.push(0);
              } else {
                arr.push(sucklingArr[calfAge - 1][period - 1]);
              }
            }
          }
          sucklingArr.push(arr);
        }
      }
      sucklingJoinPeriods.push(sucklingArr);
    }

    let sucklingTotal: any[] = [];
    sucklingJoinPeriods[0].map((month: any, index: number) => {
      sucklingTotal[index] = [];
      for (let i = 0; i < 24; i++) {
        sucklingTotal[index].push(month[i] + sucklingJoinPeriods[1][index][i]);
      }
    });

    // TESTS
    // console.log('Suckling JP 1', sucklingJoinPeriods[0])
    // console.log('Suckling JP 2', sucklingJoinPeriods[1])
    // console.log('Suckling JPs', sucklingJoinPeriods)
    // console.log('Suckling Total', sucklingTotal)

    // return jp 1, jp2, total and combined jps
    let sucklingJoinPeriodResults = {
      jp1: sucklingJoinPeriods[0],
      jp2: sucklingJoinPeriods[1],
      total: sucklingTotal,
    };

    if (!lessThan2YearsOld) {
      this.common.sucklingJoinPeriod.mature = sucklingJoinPeriodResults;
    } else {
      this.common.sucklingJoinPeriod.young = sucklingJoinPeriodResults;
    }

    return sucklingJoinPeriodResults;
  }

  // Head of stock for each period per class
  headOfStock() {
    let datasets: Dataset[] = [];
    let stockNumbers: any[] = [];
    // Start dates from selected start date - will go into next year
    let revisedStartDates = StartDates.map((sd: string, period: number) => {
      return StartDates[mod(this.periods[period] - 1, 24)];
    });

    this.stocks.forEach((s, stockIndex: number) => {
      let stockNumber: number[] = [];
      for (let period = 0; period < 24; period++) {
        let number = parseInt((s.startNumber || 0).toString());
        if (
          period >=
          revisedStartDates.indexOf(dayjs(s.purchaseDate).format("D MMM"))
        ) {
          number += parseInt(s.purchaseNumber.toString());
        }
        if (
          period >=
          revisedStartDates.indexOf(dayjs(s.saleDate).format("D MMM"))
        ) {
          number -= parseInt(s.saleNumber.toString());
        }
        stockNumber.push(number);
      }
      let color: string = colors[this.enterprise][s.class];
      if (!s.class.includes("weaned this year")) {
        // Merge duplicates
        let mergeData = datasets.filter((ds: any) => ds.label === s.class);
        if (mergeData.length > 0) {
          if (s.class === "Weaned young steers") {
          }
          mergeData[0].data = mergeData[0].data.map((d: any, ix: number) => {
            return d + stockNumber[ix];
          });
        } else {
          // Create unique dataset
          datasets[stockIndex] = {
            label: s.class,
            backgroundColor: color,
            borderColor: 'black', // color,
            borderWidth: 0.5,
            data: stockNumber,
            order: s.type === 'Breeding' ? 0 : 1
          };
        }
      } else {
        datasets[stockIndex] = {
          label: s.class + ' (ignore)',
          data: []
        };
      }
      stockNumbers.push(stockNumber);
    });

    let headOfStock = {
      count: stockNumbers,
      datasets: datasets.filter(ds => ds)
    };

    // TESTS
    // console.log("Head of Stock", stockNumbers);
    // console.log('Head of Stock Datasets', datasets)

    this.common.headOfStock = this.cleanSource(headOfStock);
    return headOfStock;
  }

  // Weaned join periods
  weanedJoinPeriod(jpNum:number, stockClass:string) {
    // Filter to only stock that produces offspring
    let stocks = this.stocks.filter((stock) => stock.class === stockClass)
    let weanedJp:any = Array.from(Array(48), () => Array(24).fill(0))

    stocks.forEach((stock, stockIndex: number) => {
      let suckling = this.common.sucklingJoinPeriod.mature
      if (stock.class.includes("1-2 years")) {
        suckling = this.common.sucklingJoinPeriod.young
      }
      if (!this.getEnterprise.livestock.joinOption && stock.class.includes("2-3 years")) {
        suckling = this.common.sucklingJoinPeriod.young
      }
      let weanPeriod = (1 + AvailableDates.indexOf(AvailableDates.filter(av => av.start === dayjs(this.getEnterprise.livestock.joinPeriods[jpNum - 1].weanDate).format('D MMM'))[0]))

      // Ages: 1 - 24
      suckling['jp' + jpNum].map((stArray: any, period: number) => {
        return stArray.map((stVal: number, age: number) => {
          if (period === 0) {
            weanedJp[period][age] = 0
          } else {
            if (age === 0) {
              if (this.periods[age] !== weanPeriod) {
                weanedJp[period][age] = 0
              } else {
                weanedJp[period][age] = suckling['jp' + jpNum][period - 1][age]
              }
            } else if (age <= 23 && this.periods[age] === weanPeriod) {
              weanedJp[period][age] = suckling['jp' + jpNum][period - 1][age - 1]
            } else {
              weanedJp[period][age] = weanedJp[period - 1][age - 1]
            }
          }
        })
      })

      // Ages: 25 - 48
      weanedJp.map((wjpArray: any, age: number) => {
        return wjpArray.map((stVal: number, period: number) => {
          if (age >= 24) {
            if (period === 0) {
              weanedJp[age][period] = 0
            } else {
              weanedJp[age][period] = weanedJp[age - 1][period - 1]
            }
          }
        })
      })
    })

    if (stockClass.includes("1-2 years") && !this.getEnterprise.livestock.joinOption) {
      weanedJp = weanedJp.map((wjpArray:any[]) => {
        return wjpArray.map((wjpVal:number) => {
          return 0
        })
      })
    }

    return weanedJp
  }

  // Unweaned and weaned young
  weanedData() {
    let datasets: Dataset[] = [];
    const mothers = this.mothers;
    const stockNumbers = this.cleanSource(this.common.headOfStock.count);
    const livestock = this.getEnterprise.livestock;
    const stock = this.getEnterprise.stock;

    // UNWEANED

    let unweanedData: number[] = Array.from(Array(24), () => 0);
    let sumWeanedAtStart: number[] = Array.from(Array(24), () => 0);
    let weanedAtStartMotherJp: any[] = [];
    let offspringUnweanedNDP: any[] = [];

    for (let jpNum = 0; jpNum < livestock.joinNumber; jpNum++) {
      mothers.forEach((mother: any, motherIndex: number) => {
        let numbers =
          stockNumbers[
            Breeds[this.enterprise].classes.breeding.indexOf(mother as never)
          ];
        numbers.unshift(numbers[0]);

        let sucklingJp = this.cleanSource(
          this.common.sucklingJoinPeriod.mature
        )["jp" + (jpNum + 1)];
        let jp = livestock.joinPeriods[jpNum];
        let noneAtStart = false;

        // Handle none present at start exception for (1-2 years)
        if (mother.includes("1-2 years")) {
          noneAtStart = true;
          sucklingJp = (this.cleanSource(this.sucklingJoinPeriod(true)) as any)["jp" + (jpNum + 1)];
        }

        // Handle join option for yearlings
        if (!this.getEnterprise.livestock.joinOption && mother.includes("2-3 years")) {
          noneAtStart = true;
          sucklingJp = (this.cleanSource(this.sucklingJoinPeriod(true)) as any)["jp" + (jpNum + 1)];
        }

        // Sum of suckling periods
        let sucklingJpPeriodSums: number[] = Array.from(Array(24), () => 0);
        for (let period = 0; period < 24; period++) {
          sucklingJp.forEach((array: any) => {
            sucklingJpPeriodSums[period] += array[period];
          });
        }
        // console.log('Suckling Join Period Sums', sucklingJpPeriodSums)

        // Unweaned offspring numbers during period
        // Number of stock for given period * sum of suckling join period
        let unweanedNDP: number[] = Array.from(Array(24), () => 0);
        sucklingJpPeriodSums.map((suckling: number, period: number) => {
          unweanedNDP[period] = numbers[period + 1] * suckling;
        });

        // Offspring numbers during period (start)
        if (!noneAtStart) {
          unweanedNDP.unshift(
            numbers[numbers.length - 1] > 0
              ? (numbers[0] / numbers[numbers.length - 1]) *
                  unweanedNDP[unweanedNDP.length - 1]
              : unweanedNDP[0]
          );
        } else {
          unweanedNDP.unshift(unweanedNDP[0]);
        }
        // console.log((this.enterprise === 'cattle' ? 'Calf' : 'Lamb') + ' unweaned numbers during period', unweanedNDP)
        offspringUnweanedNDP.push(unweanedNDP)

        // Calves / lambs weaned at start of period
        let weanedAtStart: number[] = [];
        for (let period = 0; period < unweanedNDP.length - 1; period++) {
          // Calves / lambs weaned at start of period
          weanedAtStart.push(
            this.trim(
            this.periods[period] ===
              StartDates.indexOf(dayjs(jp.weanDate).format("D MMM")) + 1
              ? unweanedNDP[period]
              : 0
            )
          );
          sumWeanedAtStart[period] += weanedAtStart[period];
        }
        weanedAtStartMotherJp.push(weanedAtStart);
        // console.log((this.enterprise === 'cattle' ? 'Calves' : 'Lambs') + ' weaned at start of period', weanedAtStart)

        // Total unweaned
        unweanedNDP.map((undp: number, period: number) => {
          if (period > 0) {
            unweanedData[period - 1] += undp;
          }
        });
      });
    }

    // WEANED

    let weanedData: any[] = Array.from(Array(24), () => 0);
    let offspringSoldAtStart: any[] = Array.from(Array(mothers.length * livestock.joinNumber), () => []);
    let offspringWeanedNDP: any[] = Array.from(Array(mothers.length * livestock.joinNumber), () => []);
    let weanedStock = stock.filter((s: any) =>
      s.class.includes("weaned this year")
    )[0];
    let sellOn =
      StartDates.indexOf(dayjs(weanedStock.saleDate).format("D MMM")) + 1;
    let sellNum = weanedStock.saleNumber;
    let count = 0; // index: 0, 1, 2, 3, 4, 5

    // For each period
    for (let period = 0; period < 24; period++) {
      count = 0;
      // For each join
      for (let jpNum = 0; jpNum < livestock.joinNumber; jpNum++) {
        // For each mother
        // Calculate offspring sold at start of period and weaned numbers during period
        mothers.forEach((mother: any, motherIndex: number) => {
          let weanedAtStart = weanedAtStartMotherJp[count][period] || 0;
          let weanedNDP = period === 0 ? 0 : offspringWeanedNDP[count][period - 1];
          let soldAtStart = getSoldAtStart(
            this.periods,
            period,
            weanedAtStart,
            weanedNDP
          );
          offspringSoldAtStart[count].push(soldAtStart);
          offspringWeanedNDP[count].push(
            this.trim(
              Math.max(0, weanedNDP + weanedAtStart - soldAtStart)
            )
          );
          count++;
        });
      }
    }

    // Calculate the number of offspring sold at start of period
    function getSoldAtStart(
      periods: number[],
      currentPeriod: number,
      weanedAtStart: number,
      weanedNDP: number
    ) {
      let combinedSum = 0;
      if (currentPeriod === 0) {
        combinedSum = sumWeanedAtStart[currentPeriod];
      } else {
        let sumWeanedNDP = 0;
        offspringWeanedNDP.map((wa: any) => {
          sumWeanedNDP += wa[currentPeriod - 1];
        });
        combinedSum = sumWeanedAtStart[currentPeriod] + sumWeanedNDP;
      }
      let result = (periods[currentPeriod] === sellOn && weanedNDP + weanedAtStart) > 0
        ? (sellNum * (weanedNDP + weanedAtStart)) / combinedSum
        : 0;
      return result >= 0 ? result : 0
    }

    // Get total weaned number during period
    offspringWeanedNDP.map((wndpArray: any) => {
      wndpArray.map((wndpVal: number, period: number) => {
        weanedData[period] += wndpVal;
      });
    });

    // Add weaned chart dataset
    let weanedLabel: string =
      (this.enterprise === "cattle" ? "Calves" : "Lambs") + " weaned this year";
    let weanedColor: CanvasPattern = colors[this.enterprise][weanedLabel];
    datasets.push({
      label: weanedLabel,
      backgroundColor: weanedColor,
      borderColor: 'black', // weanedColor,
      borderWidth: 0.5,
      data: weanedData.map(v => { return (v < 0 ? 0 : v) })
    });

    // Add unweaned chart dataset
    let unweanedLabel: string =
    this.enterprise === "cattle" ? "Unweaned calves" : "Unweaned lambs";
    let unweanedColor: string = colors[this.enterprise][unweanedLabel];
    datasets.push({
      label: unweanedLabel,
      backgroundColor: unweanedColor,
      borderColor: 'black', // unweanedColor,
      borderWidth: 0.5,
      data: unweanedData.map(v => { return (v < 0 ? 0 : v) })
    });

    // TESTS
    // console.log('Sold at start', offspringSoldAtStart)
    // console.log('Weaned at start of period', weanedAtStartMotherJp)
    // console.log('Weaned numbers during period', offspringWeanedNDP)
    // console.log('Unweaned ' + (this.enterprise === 'cattle' ? 'calves' : 'lambs'), unweanedData)
    // console.log('Weaned ' + (this.enterprise === 'cattle' ? 'calves' : 'lambs'), weanedData)
    // console.log('Unweaned / weaned datasets', datasets)

    let results = {
      mothers: {
        unweaned: {
          start: weanedAtStartMotherJp,
          during: offspringUnweanedNDP
        },
        weaned: {
          during: offspringWeanedNDP
        }
      },
      unweaned: unweanedData,
      weaned: weanedData,
      datasets: datasets
    };

    this.common.weanedData = this.cleanSource(results);
    return results;
  }

  // Proportion lactating
  proportionLactating() {
    let proportionLactatingTotals: any[] = [];

    let sucklingJp = this.cleanSource(
      this.common.sucklingJoinPeriod.mature
    )

    this.stocks.forEach((stock, index: number) => {
      let sucklingJpTotal = sucklingJp.total
      let proportionLactating: number[] = [];
      // Handle none present at start exception for (1-2 years)
      if (stock.class.includes("1-2 years")) {
        sucklingJpTotal = (this.cleanSource(this.sucklingJoinPeriod(true)) as any).total;
        if (!this.getEnterprise.livestock.joinOption) {
          sucklingJpTotal = sucklingJpTotal.map((sjptArray:any[]) => {
            return sjptArray.map((sjtpVal:number) => {
              return 0
            })
          })
        }
      }
      // Handle join option for yearlings
      if (!this.getEnterprise.livestock.joinOption && stock.class.includes("2-3 years")) {
        sucklingJpTotal = (this.cleanSource(this.sucklingJoinPeriod(true)) as any).total;
      }

      for (let i = 0; i < sucklingJpTotal.length; i++) {
        let total = 0;
        for (let j = 0; j < sucklingJpTotal[i].length; j++) {
          total += sucklingJpTotal[j][i];
        }
        proportionLactating.push(total);
      }
      proportionLactatingTotals.push(proportionLactating);
    });

    // TESTS
    // console.log('Proportion Lactating', proportionLactatingTotals)

    return proportionLactatingTotals;
  }

  // Gain: k(gf), k(g) - lactating, k(g) - dry, k(g)
  gainKg() {
    const midpoints = this.midpointDOY;
    const dmdi = this.common.dmdi;
    const proportionLactating = this.proportionLactating();
    const location = LOCATIONS.filter(
      (location: any) => location.ID === store.state.pasture!.simulation.location
    )[0];
    const latitude: number = location.Latitude;
    const standardPasture: number = location.Legume;
    const weightings = this.common.weighting;
    const weightChange = this.common.weightChange;

    let legumeFractions: number[] = [];
    let combinedPasture: number[] = [];
    if (store.state.pasture!.simulation.growthRateSource === "Add Pasture Types") {
      for (
        let pNum = 0;
        pNum < store.state.pasture!.simulation.pastures.length;
        pNum++
      ) {
        let legume = PASTURES.filter(
          (e: any) =>
            e.LocationID === store.state.pasture!.simulation.location &&
            e.Pasture === store.state.pasture!.simulation.pastures[pNum].type
        )[0].Legume;
        // console.log('Legume (' + store.state.pasture!.simulation.pastures[i].type + ')', legume)
        legumeFractions.push(legume);
      }

      for (let period = 0; period < 24; period++) {
        let combined: number = 0;
        for (
          let pNum = 0;
          pNum < store.state.pasture!.simulation.pastures.length;
          pNum++
        ) {
          combined +=
            legumeFractions[pNum] * weightings[pNum][Math.floor(period / 2)];
        }
        combinedPasture.push(combined);
      }
    }

    let finalPasture: number[] = [];
    for (let period = 0; period < 24; period++) {
      finalPasture.push(
        store.state.pasture!.simulation.growthRateSource ===
          "Add Pasture Types"
          ? combinedPasture[period]
          : standardPasture
      );
    }

    let gainKgfArrs: any = [];
    let gainKgLactatingArrs: any = [];
    let gainKgDryArrs: any = [];
    let gainKgArrs: any = [];
    this.stocks.forEach((stock, stockIndex: number) => {
      let gainKgf: number[] = [];
      let gainKgLactating: number[] = [];
      let gainKgDry: number[] = [];
      let gainKg: number[] = [];
      for (let period = 0; period < 24; period++) {
        if (weightChange[stockIndex]) {
          let mdSolid = 17 * dmdi[period] - 2;
          let lactation = 0.4 + 0.02 * mdSolid;
          let maintKm = 0.5 + 0.02 * (17 * dmdi[period] - 2);

          // k(gf)
          let kgf =
            0.035 *
            (1 + 0.33 * finalPasture[mod(this.periods[period] - 1, 24)]) *
            (1 +
              0.12 *
                (latitude / 40) *
                Math.sin((2 * Math.PI * midpoints[period]) / 365)) *
            mdSolid;

          gainKgf.push(this.trim(kgf || 0));

          // k(g) - lactating
          let kgL = this.producesOffspring.includes(stock.class)
            ? (
              weightChange[stockIndex][period] > 0
              ? 0.95 * lactation
              : lactation / 0.84
            )
            : 0;
          gainKgLactating.push(this.trim(kgL));

          // k(g) - dry
          let kgD = weightChange[stockIndex][period] > 0 ? kgf : maintKm / 0.8;
          gainKgDry.push(this.trim(kgD || 0));

          // k(g)
          let kg = this.producesOffspring.includes(stock.class)
            ? (
              (kgL * kgD) /
              (kgD * proportionLactating[stockIndex][period] +
              kgL * (1 - proportionLactating[stockIndex][period]))
            )
            : kgD;
          gainKg.push(this.trim(kg || 0))
        }
      }
      if (gainKgf.length > 0) {
        gainKgfArrs.push(gainKgf);
        gainKgLactatingArrs.push(gainKgLactating);
        gainKgDryArrs.push(gainKgDry);
        gainKgArrs.push(gainKg);
      }
    });

    let gainKg = {
      kgf: gainKgfArrs,
      kgLactating: gainKgLactatingArrs,
      kgDry: gainKgDryArrs,
      kg: gainKgArrs,
    };

    // TESTS
    // console.log('Final Pasture Legume', finalPasture)
    // console.log('k(gf)', gainKgfsArrs)
    // console.log('k(g) - Lactating', gainKgLactatingArrs)
    // console.log('k(g) - Dry', gainKgDryArrs)
    // console.log('k(g)', gainKgArrs)

    this.common.gainKg = gainKg;
    return gainKgArrs;
  }

  // Gain: Z(gain), ZF1
  gainZ() {
    const previousMaxWeight = this.common.previousMaxWeight;
    const maxNormalWeight = this.common.maxNormalWeight;
    const animalSRW = this.common.animalSRW;
    const meanConceptusWeight = this.common.meanConceptusWeight;

    // Z(gain)
    let zGains: any[] = [];
    this.stocks.forEach((stock, stockIndex: number) => {
      let zG: number[] = Array.from(Array(24), () => 0);
      zG.map((zg: any, period: number) => {
        zG[period] =
          this.trim(
            Math.min(
              previousMaxWeight[stockIndex][period] - meanConceptusWeight[stockIndex][period],
              maxNormalWeight[stockIndex][period]
            ) / animalSRW[stockIndex][period]
          );
      });
      zGains.push(zG);
    });

    // ZF1
    let zf1s = zGains.map((zgArray: any, period: number) => {
      return zgArray.map((zgVal: any, age: number) => {
        return this.trim(1 / (1 + Math.exp(6 * (zgVal - 0.4))));
      });
    });

    let gainZ = {
      zGain: zGains,
      zf1: zf1s,
    };

    // TESTS
    // console.log('Z(gain)', zGains)
    // console.log('ZF1', zf1s)

    this.common.gainZ = gainZ;
    return gainZ;
  }

  // Gain: alpha(g), beta(g)
  gainAlphaBeta() {
    const zf1 = this.common.gainZ.zf1;
    const gainZ = this.common.gainZ;
    const emptyBodyGain = this.common.weightChange.map((wcArr: any) => {
      return wcArr.map((wcVal: any) => {
        return wcVal / 1.09;
      });
    });

    let alphaGs: any[] = [];
    let betaGs: any[] = [];
    this.stocks.forEach((stock, stockIndex: number) => {
      let BC = this.BC(stockIndex);
      let alpha: number[] = [];
      let beta: number[] = [];
      for (let period = 0; period < 24; period++) {
        // alpha(g)
        alpha.push(
          this.trim(2 * zf1[stockIndex][period] * emptyBodyGain[stockIndex][period])
        );
        // beta(g)
        beta.push(
          this.trim(
            (this.param.EVGMAX -
              gainZ.zf1[stockIndex][period] * (this.param.EVGRANGE + 2) +
              13.8 *
                (BC[period] - 1) *
                Math.max(
                  0,
                  Math.min(1, (gainZ.zGain[stockIndex][period] - 0.9) / 0.07)
                )) *
              emptyBodyGain[stockIndex][period]
          )
        );
      }
      alphaGs.push(alpha);
      betaGs.push(beta);
    });

    let alphaBeta = {
      alpha: alphaGs,
      beta: betaGs,
    };

    // TESTS
    // console.log('alpha(g)', alphaGs)
    // console.log('beta(g)', betaGs)

    this.common.gainAlphaBeta = alphaBeta;
    return alphaBeta;
  }

  // Calf / Lamb: Ages, Weights, mpMax, Default Weight for Age, Actual weight for age
  offspring() {
    const minMatingIntervalPeriods = this.gestationLength / 15;
    const dwdn = this.common.pastureDwn.dwnSummary;
    const animalSRW = this.livestockWeight;
    const mothers = this.mothers

    // Calf / Lamb age (periods)
    let offspring:any = {
      ages: Array.from(Array(48), () => 0),
      weights: Array.from(Array(48), () => 0),
      mpMax: Array.from(Array(48), () => 0),
      maxNormalWeight: Array.from(Array(48), () => 0),
      normalGrowth: Array.from(Array(48), () => 0),
      defaultWeightsForAge: Array.from(Array(48), () => []),
      actualWeightsForAge: [],
      meanCorrectedWeights: {
        unweaned: Array.from(Array(this.enterprise === 'cattle' ? 6 : 4), () => []),
        weaned: Array.from(Array(this.enterprise === 'cattle' ? 6 : 4), () => [])
      }
    };

    // Ages, weights, mpMax, maxNormalWeight, normalGrowth
    for (let period = minMatingIntervalPeriods; period < 48 + minMatingIntervalPeriods; period++) {
      let index = period - minMatingIntervalPeriods;
      let offspringSRW = 1.1 * this.livestockWeight;
      offspring.ages[index] = Math.max(
        0,
        Math.round((365 * period) / 24) - this.gestationLength
      );
      offspring.weights[index] =
      this.trim(
        offspringSRW *
        (this.param.BWN +
          (1 - this.param.BWN) *
            (1 - Math.exp(-this.curvature * offspring.ages[index]))));
      offspring.mpMax[index] =
      this.trim(
        this.param.CL01 *
        Math.pow(animalSRW, 0.75) *
        Math.pow(
          (offspring.ages[index] + this.param.CL1) / this.param.CL2,
          this.param.CL3
        ) *
        Math.exp(
          this.param.CL3 *
            (1 - (offspring.ages[index] + this.param.CL1) / this.param.CL2)
        ));
      offspring.maxNormalWeight[index] =
      this.trim(
        (1.1 * this.param.SRW) *
        (this.param.BWN + (1 - this.param.BWN) *
        (1 - Math.exp(-this.curvature * offspring.ages[index]))))
      offspring.normalGrowth[index] =
      this.trim(
        this.curvature *
        ((1.1 * this.param.SRW) - offspring.maxNormalWeight[index]))
    }

    // Default calf / lamb weight for age
    let defaultWeights: any[] = [];
    offspring.weights.map((ow: number, ix: number) => {
      if (ix === 0) {
        defaultWeights[0] = Array.from(Array(24), () => ow);
      } else {
        let dwArray: any[] = [];
        for (let period = 0; period < 24; period++) {
          let ixPrev = mod(this.periods[mod(period - 1, 24)] - 2, 24);
          let ixCurr = mod(this.periods[mod(period - 1, 24)] - 1, 24);
          let dwForAge = (
          defaultWeights[ix - 1][period - 1 >= 0 ? period - 1 : 23] +
            (ow - offspring.weights[ix - 1]) +
            (dwdn[ixPrev] *
              (0.75 * offspring.weights[ix - 1] + 0.25 * ow) *
              PeriodLengths[ixPrev]) /
              2 +
            (dwdn[ixCurr] *
              (0.25 * offspring.weights[ix - 1] + 0.75 * ow) *
              PeriodLengths[ixCurr]) /
              2
          )
          dwArray.push(this.trim(dwForAge));
        }
        defaultWeights.push(dwArray);
      }
    });
    defaultWeights.map((dw: any) => dw.push(dw.shift()));
    offspring.defaultWeightsForAge = defaultWeights

    // Actual calf / lamb weight for age

    const weanedThisYearStock = this.getEnterprise.stock.filter((s:Stock) => s.class.includes('weaned this year'))[0]
    const saleWeight = weanedThisYearStock.saleWeight;

    mothers.forEach((mother, motherIndex: number) => {
      const motherStock = this.getEnterprise.stock.filter((s:Stock) => s.class === mother)[0]
      const greaterThan2YearOld: boolean = motherStock.startAge > 24;

      let unweanedAllJoinings = Array.from(Array(24), () => 0);
      defaultWeights.slice(0, 24).map((dw, dw_ix) => {
        let combinedSum = 0;
        let sucklingTotalSum = 0
        for (let period = 0; period < 24; period++) {
          combinedSum += defaultWeights[period][dw_ix] * this.common.sucklingJoinPeriod[greaterThan2YearOld ? 'mature' : 'young'].total[period][dw_ix]
          sucklingTotalSum += this.common.sucklingJoinPeriod[greaterThan2YearOld ? 'mature' : 'young'].total[period][dw_ix]
        }
        unweanedAllJoinings[dw_ix] = sucklingTotalSum > 0 ? (combinedSum / sucklingTotalSum) : 0
      })
      // console.log('Unweaned - All Joinings', unweanedAllJoinings)

      // Weaned Totals
      let weanedJpTotal1 = this.weanedJoinPeriod(1, mother)
      let weanedJpTotal2 = this.weanedJoinPeriod(2, mother)
      let weanedTotal = weanedJpTotal1.map((wt1:any, period:number) => {
        return wt1.map((wt1Value:number, age:number) => {
          return wt1Value + weanedJpTotal2[period][age]
        })
      })
      // Console log ('Total weaned', weanedTotal)

      let weanedAllJoinings = Array.from(Array(24), () => 0);
      defaultWeights.slice(0, 24).map((dw, dw_ix) => {
        let combinedSum = 0;
        let weanedCalvesTotalSum = 0
        for (let period = 0; period < 48; period++) {
          combinedSum += defaultWeights[period][dw_ix] * weanedTotal[period][dw_ix]
          weanedCalvesTotalSum += weanedTotal[period][dw_ix]
        }
        weanedAllJoinings[dw_ix] = weanedCalvesTotalSum > 0 ? (combinedSum / weanedCalvesTotalSum) : 0
      })
      // console.log('Weaned - All Joinings', weanedAllJoinings)

      let saleWeightLookup = Array.from(Array(24), () => 0);
      for (let period = 0; period < 24; period++) {
        saleWeightLookup[period] = weanedAllJoinings[period] > 0 ? weanedAllJoinings[period] : unweanedAllJoinings[period]
      }
      // console.log('Sale weight lookup', saleWeightLookup)

      const startDates = AvailableDates.map((ad:AvailableDate) => ad.start)
      const saleDatePeriod = startDates.indexOf(dayjs(weanedThisYearStock.saleDate).format('D MMM')) + 1
      // console.log('Sale date period', saleDatePeriod)

      let defaultSaleWeight = (saleWeightLookup[this.periods.indexOf(saleDatePeriod)] + saleWeightLookup[1 + mod(this.periods.indexOf(saleDatePeriod) + 22, 24)]) / 2
      let bodyCondition = Math.max(0.7, Math.min((saleWeight > 0 && defaultSaleWeight > 0 ? (saleWeight / defaultSaleWeight) : 1), 1.3))
      // console.log('Body Condition', bodyCondition)

      let actualWeightsForAge = defaultWeights.map(dw => dw.map((w:number) => w * bodyCondition))
      offspring.actualWeightsForAge.push(actualWeightsForAge)
    })
    // console.log('Actual weight for age', offspring.actualWeightsForAge)
    
    // Mean corrected weights

    let unweanedMeanCorrectedWeights:any[] = []
    let weanedMeanCorrectedWeights:any[] = []
    for (let jpNum = 1; jpNum <= 2; jpNum++) {
      mothers.forEach((mother, motherIndex: number) => {
        // Suckling & weaned jps
        let sucklingJp = this.common.sucklingJoinPeriod.mature['jp' + jpNum]
        let weanedJp = this.weanedJoinPeriod(jpNum, mother)
        if (mother.includes("1-2 years")) {
          sucklingJp = this.common.sucklingJoinPeriod.young['jp' + jpNum]
          if (!this.getEnterprise.livestock.joinOption) {
            sucklingJp = sucklingJp.map((sjptArray:any[]) => {
              return sjptArray.map((sjtpVal:number) => {
                return 0
              })
            })
          }
        }
        if (!this.getEnterprise.livestock.joinOption && mother.includes("2-3 years")) {
          sucklingJp = this.common.sucklingJoinPeriod.young['jp' + jpNum]
        }

        // Suckling and weaned jp sums
        let sjpSums:number[] = Array.from(Array(24), () => 0)
        sucklingJp.map((sjpArray:any) => {
          sjpArray.map((sjpVal:number, period:number) => {
            sjpSums[period] += sjpVal
          })
        })
        let wjpSums:number[] = Array.from(Array(48), () => 0)
        weanedJp.map((wjpArray:any) => {
          wjpArray.map((wjpVal:number, period:number) => {
            wjpSums[period] += wjpVal
          })
        })

        let unweanedMeanCorrectWeightJP: number[] = Array.from(Array(24), () => 0);
        let weanedMeanCorrectWeightJP: number[] = Array.from(Array(24), () => 0);
        for (let group = 0; group < 24; group++) {
          // Unweaned
          if (sjpSums[group] > 0) {
            sucklingJp.map((sjpArray:any, period:number) => {
              sjpArray.map((sjpVal:number, age:number) => {
                if (age === group) {
                  unweanedMeanCorrectWeightJP[group] += (sjpVal * offspring.actualWeightsForAge[motherIndex][period][age])
                }
              })
            })
            unweanedMeanCorrectWeightJP[group] = this.trim(unweanedMeanCorrectWeightJP[group] / sjpSums[group])
          } else {
            unweanedMeanCorrectWeightJP[group] = 0
          }

          // Weaned
          if (wjpSums[group] > 0) {
            weanedJp.map((wjpArray:any, period:number) => {
              wjpArray.map((wjpVal:number, age:number) => {
                if (age === group) {
                  weanedMeanCorrectWeightJP[group] += (wjpVal * offspring.actualWeightsForAge[motherIndex][period][age])
                }
              })
            })
            weanedMeanCorrectWeightJP[group] = this.trim(weanedMeanCorrectWeightJP[group] / wjpSums[group])
          } else {
            weanedMeanCorrectWeightJP[group] = 0
          }
        }
        unweanedMeanCorrectedWeights.push(unweanedMeanCorrectWeightJP)
        weanedMeanCorrectedWeights.push(weanedMeanCorrectWeightJP)
      })
    }
    offspring.meanCorrectedWeights.unweaned = unweanedMeanCorrectedWeights
    offspring.meanCorrectedWeights.weaned = weanedMeanCorrectedWeights

    // TESTS
    // console.log(this.enterprise === 'cattle' ? 'Cattle offspring' : 'Lamb offspring', offspring)

    this.common.offspring = offspring
    return offspring
  }

  // Unweaned & Current year's weaners: weights, ages, numbers etc.
  numbersWeaned () {
    const mothersWeaned = this.common.weanedData.mothers
    const livestock = this.getEnterprise.livestock;
    const offspring = this.common.offspring;
    const mothers = this.mothers;

    let currentYearWeaners:any = {
      numAtStartPriorToSales: {
        unweaned: [],
        weaned: []
      },
      weightAtMidpoint: {
        unweaned: [],
        weaned: []
      },
      weightChangeDuringPeriod: {
        unweaned: [],
        weaned: []
      },
      weightAtStartOfPeriod: {
        unweaned: [],
        weaned: []
      },
      actualLiveWeights: {
        unweaned: [],
        weaned: []
      }
    }

    let count:number = 0
    for (let jpNum = 0; jpNum < livestock.joinNumber; jpNum++) {
      mothers.forEach((mother: any, motherIndex: number) => {
        // Unweaned numbers at start of period (prior to sales)
        let unweanedNumAtStartPriorToSales:any[] = Array.from(Array(25), () => 0);
        unweanedNumAtStartPriorToSales = unweanedNumAtStartPriorToSales.map((wn:number, period:number) => {
          return mothersWeaned.unweaned.during[count][period] - (mothersWeaned.unweaned.start[count][period] || 0)
        })

        // Weaned numbers at start of period (prior to sales)
        let weanedNumAtStartPriorToSales:any[] = Array.from(Array(24), () => 0);
        weanedNumAtStartPriorToSales = weanedNumAtStartPriorToSales.map((wn:number, period:number) => {
          if (period === 0) {
            return mothersWeaned.unweaned.start[count][period]
          } else {
            return mothersWeaned.weaned.during[count][period - 1] + mothersWeaned.unweaned.start[count][period]
          }
        })

        // Unweaned weights at midpoint of period
        let unweanedWeightAtMidpoint = offspring.meanCorrectedWeights.unweaned[count]

        // Weaned weights at midpoint of period
        let weanedWeightAtMidpoint = offspring.meanCorrectedWeights.weaned[count]

        // Unweaned weight change during period (kg/d)
        let sucklingJp = this.common.sucklingJoinPeriod.mature['jp' + (jpNum + 1)]
        if (mother.includes("1-2 years")) {
          sucklingJp = this.common.sucklingJoinPeriod.young['jp' + (jpNum + 1)]
          if (!this.getEnterprise.livestock.joinOption) {
            sucklingJp = sucklingJp.map((sjptArray:any[]) => {
              return sjptArray.map((sjtpVal:number) => {
                return 0
              })
            })
          }
        }
        if (!this.getEnterprise.livestock.joinOption && mother.includes("2-3 years")) {
          sucklingJp = this.common.sucklingJoinPeriod.young['jp' + (jpNum + 1)]
        }
        let sjpSums:number[] = Array.from(Array(24), () => 0)
        sucklingJp.map((sjpArray:any) => {
          sjpArray.map((sjpVal:number, period:number) => {
            sjpSums[period] += sjpVal
          })
        })

        let unweanedWeightChangeDuringPeriod: number[] = Array.from(Array(24), () => 0);
        for (let group = 0; group < 24; group++) {
          if (sjpSums[group] > 0) {
            sucklingJp.map((sjpArray:any, period:number) => {
              sjpArray.map((sjpVal:number, age:number) => {
                if (age === group) {
                  unweanedWeightChangeDuringPeriod[group] += (sjpVal * offspring.normalGrowth[period])
                }
              })
            })
            unweanedWeightChangeDuringPeriod[group] = unweanedWeightChangeDuringPeriod[group] / sjpSums[group]
          } else {
            unweanedWeightChangeDuringPeriod[group] = 0
          }
        }

        // Weaned weight change during period (kg/d)
        let weanedJp = this.weanedJoinPeriod((jpNum + 1), mother)
        let wjpSums:number[] = Array.from(Array(48), () => 0)
        weanedJp.map((wjpArray:any) => {
          wjpArray.map((wjpVal:number, period:number) => {
            wjpSums[period] += wjpVal
          })
        })

        let weanedWeightChangeDuringPeriod: number[] = Array.from(Array(24), () => 0);
        for (let group = 0; group < 24; group++) {
          if (wjpSums[group] > 0) {
            weanedJp.map((wjpArray:any, period:number) => {
              wjpArray.map((wjpVal:number, age:number) => {
                if (age === group) {
                  weanedWeightChangeDuringPeriod[group] += (wjpVal * offspring.normalGrowth[period])
                }
              })
            })
            weanedWeightChangeDuringPeriod[group] = weanedWeightChangeDuringPeriod[group] / wjpSums[group]
          } else {
            weanedWeightChangeDuringPeriod[group] = 0
          }
        }

        // Unweaned weights at start of period (prior to sales)
        let unweanedWeightAtStartOfPeriod: number[] = Array.from(Array(25), () => 0);
        unweanedWeightAtStartOfPeriod = unweanedWeightAtStartOfPeriod.map((uw:number, period:number) => {
          if (period === 0) {
            return unweanedWeightAtMidpoint[period] - unweanedWeightChangeDuringPeriod[period] *
            (dayjs(cleanDate(AvailableDates[this.periods[period]].mid, 'D MMM'), 'D MMM').dayOfYear() - dayjs(cleanDate(AvailableDates[this.periods[period]].start, 'D MMM'), 'D MMM').dayOfYear())
          } else {
            return unweanedWeightAtMidpoint[period - 1] + unweanedWeightChangeDuringPeriod[period - 1] *
            mod(dayjs(cleanDate(AvailableDates[this.periods[period < 24 ? period : 0]].start, 'D MMM'), 'D MMM').dayOfYear() - dayjs(cleanDate(AvailableDates[this.periods[period - 1]].mid, 'D MMM'), 'D MMM').dayOfYear(), 365)
          }
        })

        // Weaned weights at start of period (prior to sales)
        let weanedWeightAtStartOfPeriod: number[] = Array.from(Array(24), () => 0);
        weanedWeightAtStartOfPeriod = weanedWeightAtStartOfPeriod.map((uw:number, period:number) => {
          const weanOn = StartDates.indexOf(dayjs(this.getEnterprise.livestock.joinPeriods[jpNum].weanDate).format("D MMM")) + 1;
          let weight:number = 0
          if (period === 0) {
            weight = unweanedWeightAtMidpoint[period] - unweanedWeightChangeDuringPeriod[period] *
            mod(dayjs(cleanDate(AvailableDates[this.periods[period]].start, 'D MMM'), 'D MMM').dayOfYear() - dayjs(cleanDate(AvailableDates[this.periods[mod(period - 1, 24)]].mid, 'D MMM'), 'D MMM').dayOfYear(), 365)
          } else {
            if (this.enterprise === 'cattle' && jpNum + 1 === livestock.joinNumber) {
              weight = unweanedWeightAtMidpoint[period - 1] + unweanedWeightChangeDuringPeriod[period - 1] *
              mod(dayjs(cleanDate(AvailableDates[this.periods[period]].start, 'D MMM'), 'D MMM').dayOfYear() - dayjs(cleanDate(AvailableDates[this.periods[period - 1]].mid, 'D MMM'), 'D MMM').dayOfYear(), 365)
            } else {
              weight = weanedWeightAtMidpoint[period - 1] + weanedWeightChangeDuringPeriod[period - 1] *
              mod(dayjs(cleanDate(AvailableDates[this.periods[period]].start, 'D MMM'), 'D MMM').dayOfYear() - dayjs(cleanDate(AvailableDates[this.periods[period - 1]].mid, 'D MMM'), 'D MMM').dayOfYear(), 365)
            }
          }
          if (this.periods[period] === weanOn) {
            weight = unweanedWeightAtStartOfPeriod[period]
          }
          return weight
        })

        currentYearWeaners.numAtStartPriorToSales.unweaned.push(unweanedNumAtStartPriorToSales)
        currentYearWeaners.numAtStartPriorToSales.weaned.push(weanedNumAtStartPriorToSales)
        currentYearWeaners.weightAtMidpoint.unweaned.push(unweanedWeightAtMidpoint)
        currentYearWeaners.weightAtMidpoint.weaned.push(weanedWeightAtMidpoint)
        currentYearWeaners.weightChangeDuringPeriod.unweaned.push(unweanedWeightChangeDuringPeriod)
        currentYearWeaners.weightChangeDuringPeriod.weaned.push(weanedWeightChangeDuringPeriod)
        currentYearWeaners.weightAtStartOfPeriod.unweaned.push(unweanedWeightAtStartOfPeriod)
        currentYearWeaners.weightAtStartOfPeriod.weaned.push(weanedWeightAtStartOfPeriod)

        // Actual Live Weight (kg) - Period Start
        if ((jpNum + 1) === livestock.joinNumber) {
          // Unweaned
          let actualLiveWeightPeriodStart: number[] = Array.from(Array(25), () => 0);
          actualLiveWeightPeriodStart = actualLiveWeightPeriodStart.map((lw:number, period:number) => {
            if (livestock.joinNumber === 2) {
              let increment = 0
              if (this.enterprise === 'cattle') {
                increment = this.getEnterprise.livestock.joinOption ? 2 : 1
              } else {
                increment = this.getEnterprise.livestock.joinOption ? 1 : 0
              }
              let sumUnweanedNum:number = (
                currentYearWeaners.numAtStartPriorToSales.unweaned[count][period] +
                currentYearWeaners.numAtStartPriorToSales.unweaned[count - (jpNum + increment)][period]
              )
              if (sumUnweanedNum > 0) {
                return (
                  (
                    (currentYearWeaners.numAtStartPriorToSales.unweaned[count][period] * currentYearWeaners.weightAtStartOfPeriod.unweaned[count][period]) +
                    (currentYearWeaners.numAtStartPriorToSales.unweaned[count - (jpNum + increment)][period] * currentYearWeaners.weightAtStartOfPeriod.unweaned[count - (jpNum + increment)][period])
                  ) / sumUnweanedNum
                )
              } else {
                return 0
              }
            } else {
              let unweanedNum:number = currentYearWeaners.numAtStartPriorToSales.unweaned[count][period]
              if (unweanedNum > 0) {
                return (
                  (
                    (currentYearWeaners.numAtStartPriorToSales.unweaned[count][period] * currentYearWeaners.weightAtStartOfPeriod.unweaned[count][period])
                  ) / unweanedNum
                )
              } else {
                return 0
              }
            }
          })
          currentYearWeaners.actualLiveWeights.unweaned.push(actualLiveWeightPeriodStart)

          // Weaned
          actualLiveWeightPeriodStart = Array.from(Array(24), () => 0);
          actualLiveWeightPeriodStart = actualLiveWeightPeriodStart.map((lw:number, period:number) => {
            if (livestock.joinNumber === 2) {
              let increment = 0
              if (this.enterprise === 'cattle') {
                increment = this.getEnterprise.livestock.joinOption ? 2 : 1
              } else {
                increment = this.getEnterprise.livestock.joinOption ? 1 : 0
              }
              let sumWeanedNum:number = (
                currentYearWeaners.numAtStartPriorToSales.weaned[count][period] +
                currentYearWeaners.numAtStartPriorToSales.weaned[count - (jpNum + increment)][period]
              )
              if (sumWeanedNum > 0) {
                return (
                  (
                    (currentYearWeaners.numAtStartPriorToSales.weaned[count][period] * currentYearWeaners.weightAtStartOfPeriod.weaned[count][period]) +
                    (currentYearWeaners.numAtStartPriorToSales.weaned[count - (jpNum + increment)][period] * currentYearWeaners.weightAtStartOfPeriod.weaned[count - (jpNum + increment)][period])
                  ) / sumWeanedNum
                )
              } else {
                return 0
              }
            } else {
              let weanedNum:number = currentYearWeaners.numAtStartPriorToSales.weaned[count][period]
              if (weanedNum > 0) {
                return (
                  (
                    (currentYearWeaners.numAtStartPriorToSales.weaned[count][period] * currentYearWeaners.weightAtStartOfPeriod.weaned[count][period])
                  ) / weanedNum
                )
              } else {
                return 0
              }
            }
          })
          currentYearWeaners.actualLiveWeights.weaned.push(actualLiveWeightPeriodStart)
        }

        count++
      })
    }

    // TEST
    // console.log("Current year's weaners", currentYearWeaners)

    return currentYearWeaners
  }

  // Iterations: Standard Stock
  iterations() {
    const weightChange = this.common.weightChange;
    const meMetabGraze = this.common.meMetabGraze;
    const pregnancy = this.common.pregnancy;
    const lactation = this.common.lactation;
    const gainAlphaBeta = this.common.gainAlphaBeta;
    const woolGrowth = this.common.woolGrowth;
    const gainKg = this.common.gainKg;
    const conception = this.common.conceptionRate
    const offspring = this.common.offspring
    const { CL21, CL22 } = this.param;

    let stockIterations: any[] = [];
    this.stocks.forEach((stock, stockIndex: number) => {
      const iterations = {
        i1: {
          MEItotal: Array.from(Array(24), () => 0),
          MEm: Array.from(Array(24), () => 0),
          L: Array.from(Array(24), () => 0),
          MEl: Array.from(Array(24), () => 0),
          NEg: Array.from(Array(24), () => 0),
          NEw: Array.from(Array(24), () => 0),
        },
        i2: {
          MEItotal: Array.from(Array(24), () => 0),
          MEm: Array.from(Array(24), () => 0),
          L: Array.from(Array(24), () => 0),
          MElArray: Array.from(Array(24), () => 0),
          MEl: Array.from(Array(24), () => 0),
          NEg: Array.from(Array(24), () => 0),
          NEw: Array.from(Array(24), () => 0),
        },
        i3: {
          MEItotal: Array.from(Array(24), () => 0),
        },
      };

      if (this.producesOffspring.includes(stock.class)) {
        // ME(c)
        const MEc = pregnancy.mean[stockIndex];

        // BC
        const BC = this.BC(stockIndex);

        // Total suckling number per mother
        let sucklingTotal = this.cleanSource(
          this.common.sucklingJoinPeriod.mature.total
        );
        if (stock.class.includes("1-2 years")) {
          sucklingTotal = this.cleanSource(
            this.common.sucklingJoinPeriod.young.total
          );
          if (!this.getEnterprise.livestock.joinOption) {
            sucklingTotal = sucklingTotal.map((sjptArray:any[]) => {
              return sjptArray.map((sjtpVal:number) => {
                return 0
              })
            })
          }
        }
        if (!this.getEnterprise.livestock.joinOption && stock.class.includes("2-3 years")) {
          sucklingTotal = this.cleanSource(
            this.common.sucklingJoinPeriod.young.total
          );
        }

        // ----------------- ITERATION 1 -----------------

        let it1 = iterations.i1;

        // (start) L
        it1.L.map((l: number, ix: number) => {
          it1.L[ix] = weightChange[stockIndex][ix] < 0 ? 0 : 0.5;
        });
        // console.log('(start) L', it1.L)

        // ME(m)
        it1.MEm.map((mem: number, ix: number) => {
          it1.MEm[ix] =
            this.trim((meMetabGraze[stockIndex][ix] || 0) / (1 - 0.09 * (it1.L[ix] + 1)));
        });
        // console.log('ME(m)', it1.MEm)

        // MEI(total)
        it1.MEItotal.map((meiTotal: number, ix: number) => {
          it1.MEItotal[ix] = this.trim(it1.MEm[ix] * (it1.L[ix] + 1));
        });
        // console.log('MEI(total)', it1.MEItotal)

        // Scalar for MP(max)
        let scalarForMPMax = Array.from(Array(24), () => 1)
        if (this.enterprise === 'sheep') {
          let singles = conception.lambs.survivingTotals.single
          let twins = conception.lambs.survivingTotals.twins

          scalarForMPMax = scalarForMPMax.map((scalar, period) => {
            if (twins[mod(period - this.gestationPeriods, 24)] === 0) {
              return 1
            } else {
              const incrementToMPMaxForTwins = (this.param.CL02 || 0) / this.param.CL01 - 1
              return 1 + (
                incrementToMPMaxForTwins *
                twins[mod(period - this.gestationPeriods, 24)] /
                (singles[mod(period - this.gestationPeriods, 24)] + twins[mod(period - this.gestationPeriods, 24)])
              )
            }
          })
        }
        // console.log('Scalar for MP(max)', scalarForMPMax)

        // MP(max)
        let Z = this.Z(stockIndex);
        let mpMax = sucklingTotal.map((stArray: any, period: number) => {
          return stArray.map((stVal: any, age: number) => {
            if (this.enterprise === 'cattle') {
              return stVal === 0 ? 0 : offspring.mpMax[period] * Z[age];
            } else {
              return stVal === 0 ? 0 : scalarForMPMax[mod(this.periods[age] - period - 1, 24)] * offspring.mpMax[period] * Z[age];
            }
          });
        });
        // console.log("MP(max)", mpMax);

        // MR
        const gestationPeriods = this.gestationPeriods;
        let MR = sucklingTotal.map((stArray: any, period: number) => {
          return stArray.map((stVal: any, age: number) => {
            return stVal === 0
              ? 0
              : (0.94 *
                  lactation[age] *
                  (it1.MEItotal[age] -
                    it1.MEm[age] -
                    pregnancy.raw[stockIndex][(period + gestationPeriods) % 24])) /
                  Math.max(1, mpMax[period][age]);
          });
        });
        // console.log("MR", MR);

        // AD
        let AD = sucklingTotal.map((stArray: any, period: number) => {
          return stArray.map((stVal: any, age: number) => {
            return stVal === 0
              ? 0
              : Math.max(offspring.ages[period], MR[period][age] / (2 * CL22));
          });
        });
        // console.log('AD', AD)

        // MP(1)
        let MP1 = sucklingTotal.map((stArray: any, period: number) => {
          return stArray.map((stVal: any, age: number) => {
            if (
              1.6 -
                4 * MR[period][age] -
                CL21 *
                  AD[period][age] *
                  (MR[period][age] - CL22 * AD[period][age]) +
                3 * BC[period] * (MR[period][age] - 0.6 * BC[period]) >
                100 ||
              stVal === 0
            ) {
              return 0;
            } else {
              return (
                (1.17 * mpMax[period][age]) /
                (1 +
                  Math.exp(
                    1.6 -
                      4 * MR[period][age] -
                      CL21 *
                        AD[period][age] *
                        (MR[period][age] - CL22 * AD[period][age]) +
                      3 * BC[age] * (MR[period][age] - 0.6 * BC[age])
                  ))
              );
            }
          });
        });
        // console.log("MP(1)", MP1);

        // MP(y)
        let MPy: any[] = [];
        offspring.actualWeightsForAge[0].map((dwArray: any, period: number) => {
          if (period < 24) {
            MPy.push(
              dwArray.map((dwVal: any) => {
                let MPy =
                  this.param.CL6 *
                  Math.pow(dwVal, 0.75) *
                  (this.param.CL12 +
                    this.param.CL13 *
                      Math.exp(-this.param.CL14 * offspring.ages[period]));
                return MPy;
              })
            );
          }
        });
        // console.log('MP(y)', MPy)

        let MElArray = sucklingTotal.map((stArray: any, period: number) => {
          return stArray.map((stVal: any, age: number) => {
            return (
              this.trim(Math.min(MP1[period][age], MPy[period][age]) /
              (0.94 * lactation[age]))
            );
          });
        });
        // console.log('ME(l)', MElArray)

        // ME(l)
        let sumsArr: number[] = Array.from(Array(24), () => 0);
        for (let group = 0; group < 24; group++) {
          sucklingTotal.map((stArray: any, period: number) => {
            stArray.map((stVal: number, age: number) => {
              if (age === group) {
                it1.MEl[group] += this.trim(stVal * MElArray[period][age]);
              }
            });
          });
        }
        // console.log("ME(l)", it1.MEl);

        // NE(g)
        it1.NEg.map((ne: number, ix: number) => {
          it1.NEg[ix] =
            gainAlphaBeta.beta[stockIndex][ix] +
            gainAlphaBeta.alpha[stockIndex][ix] * it1.L[ix];
        });
        // console.log("NE(g)", it1.NEg);

        // NE(w)
        it1.NEw.map((ne: number, ix: number) => {
          it1.NEw[ix] =
            woolGrowth.alpha[stockIndex][ix] *
            (Math.max(0, it1.MEItotal[ix] - MEc[ix] - it1.MEl[ix])) -
            woolGrowth.beta[stockIndex][ix];
        });
        // console.log('NE(w)', it1.NEw)

        // ----------------- ITERATION 2 -----------------

        let it2 = iterations.i2;

        // MEI(total)
        it2.MEItotal.map((meiTotal: number, ix: number) => {
          it2.MEItotal[ix] =
            this.trim((meMetabGraze[stockIndex][ix] +
              MEc[ix] +
              it1.MEl[ix] +
              (it1.NEg[ix] + it1.NEw[ix]) /
                gainKg.kg[stockIndex][ix]) /
            (1 - 0.09));
        });
        // console.log('MEI(total)', it2.MEItotal)

        // ME(m)
        it2.MEm.map((mem: number, ix: number) => {
          it2.MEm[ix] = this.trim(meMetabGraze[stockIndex][ix] + 0.09 * it2.MEItotal[ix]);
        });
        // console.log('ME(m)', it2.MEm)

        // L
        it2.L.map((L: number, ix: number) => {
          it2.L[ix] = this.trim(it2.MEItotal[ix] / Math.max(1, it2.MEm[ix]) - 1);
        });
        // console.log('L', it2.L)

        // MR
        MR = sucklingTotal.map((stArray: any, period: number) => {
          return stArray.map((stVal: any, age: number) => {
            return stVal === 0
              ? 0
              : (0.94 *
                  lactation[age] *
                  (it2.MEItotal[age] -
                    it2.MEm[age] -
                    pregnancy.raw[stockIndex][mod(period + this.gestationPeriods, 24)])) /
                  Math.max(1, mpMax[period][age]);
          });
        });
        // console.log("MR", MR);

        // MP(1)
        MP1 = sucklingTotal.map((stArray: any, period: number) => {
          return stArray.map((stVal: any, age: number) => {
            if (
              1.6 -
                4 * MR[period][age] -
                this.param.CL21 *
                  AD[period][age] *
                  (MR[period][age] - this.param.CL22 * AD[period][age]) +
                3 * BC[period] * (MR[period][age] - 0.6 * BC[period]) >
                100 ||
              stVal === 0
            ) {
              return 0;
            } else {
              return (
                (1.17 * mpMax[period][age]) /
                Math.max(
                  1,
                  1 +
                    Math.exp(
                      1.6 -
                        4 * MR[period][age] -
                        this.param.CL21 *
                          AD[period][age] *
                          (MR[period][age] - this.param.CL22 * AD[period][age]) +
                        3 * BC[age] * (MR[period][age] - 0.6 * BC[age])
                    )
                )
              );
            }
          });
        });
        // console.log("MP(1)", MP1);

        MElArray = sucklingTotal.map((stArray:any, period:number) => {
          return stArray.map((stVal:any, age:number) => {
            return this.trim(Math.min(MP1[period][age], MPy[period][age]) / (0.94 * lactation[age]))
          })
        })
        it2.MElArray = MElArray
        // console.log('ME(l)', MElArray)

        // ME(l)
        sumsArr = Array.from(Array(24), () => 0);
        for (let group = 0; group < 24; group++) {
          sucklingTotal.map((stArray: any, period: number) => {
            stArray.map((stVal: number, age: number) => {
              if (age === group) {
                it2.MEl[group] += this.trim(stVal * MElArray[period][age]);
              }
            });
          });
        }
        // console.log("ME(l)", it2.MEl);

        // NE(g)
        it2.NEg.map((ne: number, ix: number) => {
          it2.NEg[ix] =
            this.trim(gainAlphaBeta.beta[stockIndex][ix] +
            gainAlphaBeta.alpha[stockIndex][ix] * it2.L[ix]);
        });
        // console.log("NE(g)", it2.NEg);

        // NE(w)
        it2.NEw.map((ne: number, ix: number) => {
          it2.NEw[ix] =
            woolGrowth.alpha[stockIndex][ix] *
            (Math.max(0, it2.MEItotal[ix] - MEc[ix] - it2.MEl[ix])) -
            woolGrowth.beta[stockIndex][ix];
        });
        // console.log("NE(w)", it2.NEw);

        // ----------------- ITERATION 3 -----------------

        let it3 = iterations.i3;

        // MEI(total)
        let nonReproductive = [
          "Steers (1-2 years)",
          "Weaned young heifers",
          "Weaned young steers",
          "Wethers (1-2 years)",
          "Weaned young ewes",
          "Weaned young wethers",
        ];

        if (
          stock.type === "Trading" ||
          nonReproductive.indexOf(stock.class) > -1
        ) {
          it3.MEItotal.map((meiTotal: number, ix: number) => {
            let a =
              0.09 *
              (0.91 * gainKg.kgDry[stockIndex][ix] -
                woolGrowth.alpha[stockIndex][ix]);
            let b =
              (0.82 * gainKg.kgDry[stockIndex][ix] -
                woolGrowth.alpha[stockIndex][ix]) *
                meMetabGraze[stockIndex][ix] -
              0.09 *
                (gainAlphaBeta.beta[stockIndex][ix] -
                  woolGrowth.beta[stockIndex][ix]) -
              0.91 * gainAlphaBeta.alpha[stockIndex][ix];
            let c =
              -(
                gainKg.kgDry[stockIndex][ix] * meMetabGraze[stockIndex][ix] +
                gainAlphaBeta.beta[stockIndex][ix] -
                gainAlphaBeta.alpha[stockIndex][ix] -
                woolGrowth.beta[stockIndex][ix]
              ) * meMetabGraze[stockIndex][ix];
            it3.MEItotal[ix] =
              this.trim((Math.pow((Math.pow(b, 2) - ((4 * a) * c)), 0.5) - b) / (2 * a));
          });
        } else {
          it3.MEItotal.map((meiTotal: number, ix: number) => {
            it3.MEItotal[ix] =
              this.trim((meMetabGraze[stockIndex][ix] +
                MEc[ix] +
                it2.MEl[ix] +
                (it2.NEg[ix] + it2.NEw[ix]) / gainKg.kg[stockIndex][ix]) /
              (1 - 0.09));
          });
        }
        // console.log(stock.class + ' MEI(total)', it3.MEItotal)

        stockIterations.push(iterations);
      } else {
        iterations.i3.MEItotal.map((meiTotal: number, ix: number) => {
          let a = 0.09 * (0.91 * (gainKg.kg[stockIndex][ix] - woolGrowth.alpha[stockIndex][ix]))
          let b = (0.82 * gainKg.kg[stockIndex][ix] - woolGrowth.alpha[stockIndex][ix]) * meMetabGraze[stockIndex][ix] - 0.09 * (gainAlphaBeta.beta[stockIndex][ix] - woolGrowth.beta[stockIndex][ix]) - 0.91 * gainAlphaBeta.alpha[stockIndex][ix]
          let c = -(gainKg.kg[stockIndex][ix] * meMetabGraze[stockIndex][ix] + gainAlphaBeta.beta[stockIndex][ix] - gainAlphaBeta.alpha[stockIndex][ix] - woolGrowth.beta[stockIndex][ix]) * meMetabGraze[stockIndex][ix]
          iterations.i3.MEItotal[ix] = (Math.pow(Math.pow(b, 2) - 4 * a * c, 0.5) - b) / (2 * a)
        })
        stockIterations.push(iterations);
      }
    });

    // TESTS
    // console.log('Iterations', stockIterations)

    this.common.iterations = stockIterations;
    return stockIterations;
  }

  // Iterations: Unweaned
  iterationsUnweaned() {
    const stockIterations = this.common.iterations;
    const lactation = this.common.lactation;
    const dwdn = this.common.pastureDwn.dwnSummary;
    const dmdi = this.common.dmdi;
    const kms = dmdi.map((dmdi: number) => 0.5 + 0.02 * (17 * dmdi - 2));
    const neGrazeLWs = dmdi.map((dmdi: number) => 0.054 - 0.049 * dmdi);
    const gainKgf = this.common.gainKg.kgf
    const offspring = this.common.offspring

    let unweanedIterations:any[] = []

    // Filter to only stock that produces offspring
    let stocks = this.stocks.filter((stock) => this.producesOffspring.indexOf(stock.class) > -1)

    stocks.forEach((stock, stockIndex: number) => {
      const iterations:any = {
        i1: {},
        i2: {},
        i3: {},
        i4: {},
        i5: {}
      }

     // Total suckling number per mother
      let sucklingTotal = this.cleanSource(
        this.common.sucklingJoinPeriod.mature.total
      );
      if (stock.class.includes("1-2 years")) {
        sucklingTotal = this.cleanSource(
          this.common.sucklingJoinPeriod.young.total
        );
        if (!this.getEnterprise.livestock.joinOption) {
          sucklingTotal = sucklingTotal.map((sjptArray:any[]) => {
            return sjptArray.map((sjtpVal:number) => {
              return 0
            })
          })
        }
      }
      if (!this.getEnterprise.livestock.joinOption && stock.class.includes("2-3 years")) {
        sucklingTotal = this.cleanSource(
          this.common.sucklingJoinPeriod.young.total
        );
      }

      // MEI(milk)
      const MEImilk = stockIterations[stockIndex].i2.MElArray.map((melArray: any, period: number) => {
        return melArray.map((melVal:any, age:number) => {
          return 0.94 * lactation[age] * stockIterations[stockIndex].i2.MElArray[period][age]
        })
      })
      // console.log('MEI(milk)', MEImilk)

      for (let iteration = 1; iteration <= 5; iteration++) {
        // MEI(forage)
        let MEIforage:any[] = []
        if (iteration === 1) {
          MEIforage = stockIterations[stockIndex].i2.MElArray.map((melArray: any) => {
            return melArray.map((melVal:any) => {
              return 0
            })
          })
        } else {
          let prevIteration = iterations['i' + (iteration - 1)]
          if (prevIteration) {
            // MEI(forage)
            MEIforage = prevIteration.MEIforage.map((arr: any, period: number) => {
              return arr.map((val: any, age: number) => {
                if (period === 0) {
                  return 0
                } else {
                  return Math.max(0, prevIteration.MEm[period][age] + (prevIteration.NEg[period][age] + prevIteration.NEw[period][age]) / prevIteration.kg[period][age] - MEImilk[period][age])
                }
              })
            })
          }
        }
        // console.log('MEI(forage)', MEIforage)

        // phi(milk)
        let phiMilk = MEImilk.map((meiMilkArray: any, period: number) => {
          return meiMilkArray.map((meMilkVal:any, age:number) => {
            if (meMilkVal !== 0) {
              if (period === 0) {
                return 1
              } else {
                return meMilkVal / (meMilkVal + MEIforage[period][age])
              }
            } else {
              return 0
            }
          })
        })
        // console.log('phi(milk)', phiMilk)

        // NE(metab)
        let neMetab = sucklingTotal.map((stArray: any, period: number) => {
          return stArray.map((stVal: number, age: number) => {
            const youngAge = Math.max(0, Math.round((365 * (this.gestationPeriods + period)) / 24) - this.gestationLength)
            if (stVal === 0) {
              return 0
            } else {
              return this.param.CM2 * Math.pow(offspring.actualWeightsForAge[this.mothers.indexOf(stock.class)][period][age], 0.75) * Math.max(0.84, Math.exp(-0.00008 * youngAge)) * (1 + (0.23 * phiMilk[period][age]))
            }
          })
        })
        // console.log('NE(metab)', neMetab)

        // k(m)
        let km = sucklingTotal.map((stArray: any, period: number) => {
          return stArray.map((stVal: number, age: number) => {
            return kms[age] * (1 - phiMilk[period][age]) + 0.85 * phiMilk[period][age]
          })
        })
        // console.log('k(m)', km)

        // ME(m)
        let MEm = sucklingTotal.map((stArray: any, period: number) => {
          return stArray.map((stVal: number, age: number) => {
            if (stVal === 0) {
              return 0
            } else {
              return (neMetab[period][age] + neGrazeLWs[age] * offspring.actualWeightsForAge[this.mothers.indexOf(stock.class)][period][age]) / km[period][age] + 0.09 * (MEIforage[period][age] + MEImilk[period][age])
            }
          })
        })
        // console.log('ME(m)', MEm)

        // L
        let L = sucklingTotal.map((stArray: any, period: number) => {
          return stArray.map((stVal: number, age: number) => {
            if (stVal === 0) {
              return 0
            } else {
              return (MEImilk[period][age] + MEIforage[period][age]) / MEm[period][age] - 1
            }
          })
        })
        // console.log('L', L)

        // alpha(w)
        let alphaW = sucklingTotal.map((stArray: any, period: number) => {
          return stArray.map((stVal: number, age: number) => {
            const youngAge = Math.max(0, Math.round((365 * (this.gestationPeriods + period)) / 24) - this.gestationLength)
            return this.param.CWA * (0.25 + 0.75 * (1 - Math.exp(-0.025 * youngAge))) * (1 + this.param.CWB * (this.daylength[age] - 12))
          })
        })
        // console.log('alpha(w)', alphaW)

        // beta(w)
        let betaW = sucklingTotal.map((stArray: any, period: number) => {
          return stArray.map((stVal: number, age: number) => {
            const srw = 1.1 * this.livestockWeight
            const bwn = this.enterprise === 'cattle' ? 0.07 : 0.10
            const youngAge = Math.max(0, Math.round((365 * (this.gestationPeriods + period)) / 24) - this.gestationLength)
            const youngMaxNormalWeight = srw * (bwn + (1 - bwn) * (1 - Math.exp(-this.curvature * youngAge)))

            let Z = youngMaxNormalWeight / (1.1 * this.livestockWeight)

            return this.param.CWB * Z
          })
        })
        // console.log('beta(w)', betaW)

        // NE(w)
        let NEw = sucklingTotal.map((stArray: any, period: number) => {
          return stArray.map((stVal: number, age: number) => {
            return alphaW[period][age] * (MEIforage[period][age] + MEImilk[period][age] - MEm[period][age]) - betaW[period][age]
          })
        })
        // console.log('NE(w)', NEw)

        // k(g)
        let kg = sucklingTotal.map((stArray: any, period: number) => {
          return stArray.map((stVal: number, age: number) => {
            return gainKgf[stockIndex][age] * (1 - phiMilk[period][age]) + 0.7 * phiMilk[period][age]
          })
        })
        // console.log('k(g)', kg)

        // NE(g)
        let NEg = sucklingTotal.map((stArray: any, period: number) => {
          return stArray.map((stVal: number, age: number) => {
            const srw = 1.1 * this.livestockWeight
            const bwn = this.enterprise === 'cattle' ? 0.07 : 0.10
            const youngAge = Math.max(0, Math.round((365 * (this.gestationPeriods + period)) / 24) - this.gestationLength)
            const youngMaxNormalWeight = srw * (bwn + (1 - bwn) * (1 - Math.exp(-this.curvature * youngAge)))
            const youngDndt = this.curvature * (srw - youngMaxNormalWeight)

            let ixCurr = mod(this.periods[mod(age - 1, 24)], 24);
            let Z = youngMaxNormalWeight / (1.1 * this.livestockWeight)
            let ZF1 = 1 / (1 + Math.exp(6 * (Z - 0.4)))
            let alphaG = 2 * ZF1 / 1.09
            let betaG = (this.param.EVGMAX - ZF1 * (this.param.EVGRANGE + 2)) / 1.09

            if (stVal === 0) {
              return 0
            } else {
              return (alphaG * L[period][age] + betaG) * (youngDndt + dwdn[ixCurr] * youngMaxNormalWeight)
            }
          })
        })
        // console.log('NE(g)', NEg)

        // MEITotal / Herbage ME Requirements
        let MEITotal:number[] = Array.from(Array(24), () => 0)
        if (iteration === 5) {
          MEIforage.map((MEIforageArr: any, period: number) => {
            return MEIforageArr.map((MEIforageVal: any, age: number) => {
              MEITotal[age] += (MEIforageVal * sucklingTotal[period][age])
            })
          })
          // console.log('MEITotal', MEITotal)
        }

        iterations['i' + iteration] = {
          MEIforage: MEIforage,
          phiMilk: phiMilk,
          neMetab: neMetab,
          km: km,
          MEm: MEm,
          L: L,
          NEw: NEw,
          kg: kg,
          NEg: NEg,
          MEITotal: MEITotal
        }
      }
      unweanedIterations.push(iterations)
      // console.log(stock.class, iterations)
    })

    // TESTS
    // console.log('Unweaned Iterations', unweanedIterations)

    this.common.iterationsUnweaned = unweanedIterations
    return unweanedIterations
  }

  // Iterations: Weaned
  iterationsWeaned() {
    const dwdn = this.common.pastureDwn.dwnSummary;
    const dmdi = this.common.dmdi;
    const gainKgf = this.common.gainKg.kgf
    const offspring = this.common.offspring

    let weanedIterations:any[] = []

    // Filter to only stock that produces offspring
    let stocks = this.stocks.filter((stock) => this.producesOffspring.indexOf(stock.class) > -1)

    stocks.forEach((stock, stockIndex: number) => {
      // Weaned JP Totals
      let weanedJpTotal1 = this.weanedJoinPeriod(1, stock.class)
      let weanedJpTotal2 = this.weanedJoinPeriod(2, stock.class)
      // console.log('Weaned jp1 total', weanedJpTotal1)
      // console.log('Weaned jp2 total', weanedJpTotal2)

      // Weaned Totals
      let weanedTotal = weanedJpTotal1.map((wt1:any, period:number) => {
        return wt1.map((wt1Value:number, age:number) => {
          return wt1Value + weanedJpTotal2[period][age]
        })
      })
      // console.log('Weaned Total', weanedTotal)

      // Weaned Total Sums
      let weanedTotalSums:number[] = Array.from(Array(24), () => 0)
      weanedTotal.map((wtArray: any, period: number) => {
        return wtArray.map((wtVal: any, age: number) => {
          weanedTotalSums[age] += wtVal
        })
      })
      // console.log('Weaned Total Sums', weanedTotalSums)

      // NE(metab)
      let neMetab = weanedTotal.map((wtArray: any, period: number) => {
        return wtArray.map((wtVal: number, age: number) => {
          const youngAge = Math.max(0, Math.round((365 * (this.gestationPeriods + period)) / 24) - this.gestationLength)
          if (wtVal === 0) {
            return 0
          } else {
            return this.param.CM2 * Math.pow(offspring.actualWeightsForAge[this.mothers.indexOf(stock.class)][period][age], 0.75) * Math.max(0.84, Math.exp(-0.00008 * youngAge))
          }
        })
      })
      // console.log('NE(metab)', neMetab)

      // Me(metab+graze)
      let meMetabGraze = weanedTotal.map((wtArray: any, period: number) => {
        return wtArray.map((wtVal: number, age: number) => {
          if (wtVal === 0) {
            return 0
          } else {
            let km = (0.5 + 0.02 * (17 * dmdi[age] - 2))
            let NEgraze = 0.054 - 0.049 * dmdi[age]
            return (neMetab[period][age] + NEgraze * offspring.actualWeightsForAge[this.mothers.indexOf(stock.class)][period][age]) / km
          }
        })
      })
      // console.log('Me(metab+graze)', meMetabGraze)

      // k(g)
      let kg = weanedTotal.map((wtArray: any, period: number) => {
        return wtArray.map((wtVal: number, age: number) => {
          const srw = 1.1 * this.livestockWeight
          const bwn = this.enterprise === 'cattle' ? 0.07 : 0.10
          const youngAge = Math.max(0, Math.round((365 * (this.gestationPeriods + period)) / 24) - this.gestationLength)
          const youngMaxNormalWeight = srw * (bwn + (1 - bwn) * (1 - Math.exp(-this.curvature * youngAge)))
          const youngDndt = this.curvature * (srw - youngMaxNormalWeight)

          let ixCurr = mod(this.periods[mod(age - 1, 24)], 24);
          let rateOfWeightChange = (youngDndt + dwdn[ixCurr] * youngMaxNormalWeight)

          if (rateOfWeightChange > 0) {
            return gainKgf[stockIndex][age]
          } else {
            let maintKm = 0.5 + 0.02 * (17 * dmdi[mod(age - 1, 24)] - 2);
            return maintKm / 0.8
          }
        })
      })
      // console.log('k(g)', kg)

      // alpha(w)
      let alphaW = weanedTotal.map((wtArray: any, period: number) => {
        return wtArray.map((wtVal: number, age: number) => {
          const youngAge = Math.max(0, Math.round((365 * (this.gestationPeriods + period)) / 24) - this.gestationLength)
          return this.param.CWA * (0.25 + 0.75 * (1 - Math.exp(-0.025 * youngAge))) * (1 + this.param.CWB * (this.daylength[age] - 12))
        })
      })

      // beta(w)
      let betaW = weanedTotal.map((wtArray: any, period: number) => {
        return wtArray.map((wtVal: number, age: number) => {
          const srw = 1.1 * this.livestockWeight
          const bwn = this.enterprise === 'cattle' ? 0.07 : 0.10
          const youngAge = Math.max(0, Math.round((365 * (this.gestationPeriods + period)) / 24) - this.gestationLength)
          const youngMaxNormalWeight = srw * (bwn + (1 - bwn) * (1 - Math.exp(-this.curvature * youngAge)))

          let Z = youngMaxNormalWeight / (1.1 * this.livestockWeight)

          return this.param.CWB * Z
        })
      })

      // quadratic eqn: a
      let quadA = weanedTotal.map((wtArray: any, period: number) => {
        return wtArray.map((wtVal: number, age: number) => {
          return 0.09 * (0.91 * kg[period][age] - alphaW[period][age])
        })
      })
      // console.log('Quadratic eqn: a', quadA)

      // quadratic eqn: b
      let quadB = weanedTotal.map((wtArray: any, period: number) => {
        const srw = 1.1 * this.livestockWeight
        const bwn = this.enterprise === 'cattle' ? 0.07 : 0.10
        const youngAge = Math.max(0, Math.round((365 * (this.gestationPeriods + period)) / 24) - this.gestationLength)
        const youngMaxNormalWeight = srw * (bwn + (1 - bwn) * (1 - Math.exp(-this.curvature * youngAge)))
        const youngDndt = this.curvature * (srw - youngMaxNormalWeight)

        return wtArray.map((wtVal: number, age: number) => {
          let ixCurr = mod(this.periods[mod(age - 1, 24)], 24);
          let Z = youngMaxNormalWeight / (1.1 * this.livestockWeight)
          let ZF1 = 1 / (1 + Math.exp(6 * (Z - 0.4)))
          let alphaG = 2 * ZF1 / 1.09
          let betaG = (this.param.EVGMAX - ZF1 * (this.param.EVGRANGE + 2)) / 1.09
          let rateOfWeightChange = (youngDndt + dwdn[ixCurr] * youngMaxNormalWeight)

          if (wtVal === 0) {
            return 0
          } else {
            return ((((0.82 * kg[period][age]) - alphaW[period][age]) * meMetabGraze[period][age]) - (0.09 * ((betaG * rateOfWeightChange) - betaW[period][age]))) - ((0.91 * alphaG) * rateOfWeightChange)
          }
        })
      })
      // console.log('Quadratic eqn: b', quadB)

      // quadratic eqn: c
      let quadC = weanedTotal.map((wtArray: any, period: number) => {
        const srw = 1.1 * this.livestockWeight
        const bwn = this.enterprise === 'cattle' ? 0.07 : 0.10
        const youngAge = Math.max(0, Math.round((365 * (this.gestationPeriods + period)) / 24) - this.gestationLength)
        const youngMaxNormalWeight = srw * (bwn + (1 - bwn) * (1 - Math.exp(-this.curvature * youngAge)))
        const youngDndt = this.curvature * (srw - youngMaxNormalWeight)

        return wtArray.map((wtVal: number, age: number) => {
          let ixCurr = mod(this.periods[mod(age - 1, 24)], 24);
          let Z = youngMaxNormalWeight / (1.1 * this.livestockWeight)
          let ZF1 = 1 / (1 + Math.exp(6 * (Z - 0.4)))
          let alphaG = 2 * ZF1 / 1.09
          let betaG = (this.param.EVGMAX - ZF1 * (this.param.EVGRANGE + 2)) / 1.09
          let rateOfWeightChange = (youngDndt + dwdn[ixCurr] * youngMaxNormalWeight)

          if (wtVal === 0) {
            return 0
          } else {
            return -(kg[period][age] * meMetabGraze[period][age] + betaG * rateOfWeightChange - alphaG * rateOfWeightChange - betaW[period][age]) * meMetabGraze[period][age]
          }
        })
      })
      // console.log('Quadratic eqn: c', quadC)

      // MER
      let MER = weanedTotal.map((wtArray: any, period: number) => {
        return wtArray.map((wtVal: number, age: number) => {
          return (Math.pow((Math.pow(quadB[period][age], 2) - 4 * quadA[period][age] * quadC[period][age]), 0.5) - quadB[period][age]) / (2 * quadA[period][age])
        })
      })
      // console.log('MER', MER)

      // MER per Weaner
      let MEITotal:number[] = Array.from(Array(24), () => 0)
      MER.map((MERarray: any, period: number) => {
        return MERarray.map((MERval: any, age: number) => {
            MEITotal[age] += (weanedTotal[period][age] * MERval)
        })
      })
      MEITotal = MEITotal.map((meiT, period) => {
        if (weanedTotalSums[period] > 0) {
          return meiT / weanedTotalSums[period]
        } else {
          return 0
        }
      })
      // console.log('MEITotal', MEITotal)

      weanedIterations.push(MEITotal)
    })

    // TESTS
    // console.log('Weaned Iterations', weanedIterations)

    this.common.iterationsWeaned = weanedIterations

    return weanedIterations
  }
  
  // ------------------------------------------------------------
  // ------------------------- Summary --------------------------
  // ------------------------------------------------------------

  // Total DM Requirement (tonne/month) Over All Animals
  totalDmRequiredAllAnimals() {
    const stocks = this.cleanSource(this.getEnterprise.stock);
    const stockIterations = this.common.iterations;
    const unweanedIterations = this.common.iterationsUnweaned;
    const weanedIterations = this.common.iterationsWeaned;
    const weanedNumbers = this.common.weanedData.mothers.weaned.during;
    const livestockNumbers = this.common.headOfStock.count;
    const meContentOfHerbageIntake = this.common.mdSolid;

    let totalDMReqs: any[] = [];
    let totalDmReqsKeyValues: any = {}

    // Add unweaned class to stocks
    let name:any = this.enterprise === 'cattle' ? 'Unweaned calves' : 'Unweaned lambs'
    stocks.push({
      class: name,
      purchaseAge: 0,
      purchaseDate: '',
      purchaseNumber: 0,
      purchaseWeight: 0,
      saleAge: 0,
      saleDate: '',
      saleNumber: 0,
      saleWeight: 0,
      startAge: 0,
      startNumber: 0,
      startWeight: 0,
      type: '',
    })
    
    stocks.forEach((stock, stockIndex: number) => {
      // Total DM Requirement (kg/period)
      let totalDMReqKgPeriod: number[] = Array.from(Array(24), () => 0);
      let monthsIndexes: number[] = [];
      for (let period:number = 0; period < 24; period++) {
        let meReqXLivestockNum:number = 0
        let periodLength:number = PeriodLengths[mod(this.periods[period] - 1, 24)]

        // Weaned
        if (stock.class.includes('weaned this year')) {
          weanedIterations.map((wi: any, wiIX: number) => {
            return wi.map((total: number, totalIX: number) => {
              if (period === totalIX) {
                let increment:number = weanedNumbers.length / 2
                if (weanedNumbers[wiIX + increment] !== undefined) {
                  meReqXLivestockNum += wi[period] * (weanedNumbers[wiIX][period] + weanedNumbers[wiIX + increment][period])
                }
              }
            })
          })
        // Unweaned
        } else if (stock.class.includes('Unweaned')) {
          unweanedIterations.map((ui: any, uiIX: number) => {
            return ui.i5.MEITotal.map((total: number, totalIX: number) => {
              if (period === totalIX) {
                meReqXLivestockNum += ui.i5.MEITotal[period] * livestockNumbers[uiIX][period]
              }
            })
          })
        // Normal Stock
        } else {
          let meRequirementPerHead = stockIterations[stockIndex].i3.MEItotal[period]
          let livestockNum = livestockNumbers[stockIndex][period]
          meReqXLivestockNum = meRequirementPerHead * livestockNum
        }

        totalDMReqKgPeriod[period] = (meReqXLivestockNum * periodLength / meContentOfHerbageIntake[period]) || 0

        monthsIndexes.push(
          dayjs(cleanDate(StartDates[mod(this.periods[period] - 1, 24)], 'D MMM'), 'D MMM').month()
        );
      }
      // console.log(stock.class + ': Total DM Requirement (kg/period)', totalDMReqKgPeriod.reduce((a, b) => a + b))

      // Total DM Requirement (tonne/month)
      let totalDMReqTonneMonth = Array.from(Array(12), () => 0);
      for (let month = 0; month < 12; month++) {
        let sum: number = 0;
        monthsIndexes.map((mi: number, index: number) => {
          if (mi === month) {
            sum += totalDMReqKgPeriod[index];
          }
        });
        totalDMReqTonneMonth[mod(month - dayjs(store.state.pasture!.simulation.date).month(), 12)] = 0.001 * sum;
      }
      totalDMReqs.push(totalDMReqTonneMonth);

      // Handle duplicates (breeding + trading stock)
      if (totalDmReqsKeyValues[stock.class]) {
        totalDmReqsKeyValues[stock.class] = totalDmReqsKeyValues[stock.class].map((dmr:number, dmr_ix:number) => {
          return dmr + totalDMReqTonneMonth[dmr_ix]
        })
      } else {
        totalDmReqsKeyValues[stock.class] = totalDMReqTonneMonth;
      }

      // console.log(stock.class + ': Total DM Requirement (tonne/month)', totalDMReqTonneMonth)
    });

    let totalDmRequiredAllAnimals = Array.from(Array(12), () => 0);
    totalDMReqs.map((tdrArray: any, stock: number) => {
      tdrArray.map((tdrVal: any, month: number) => {
        totalDmRequiredAllAnimals[month] += !tdrVal ? 0 : tdrVal;
      });
    });

    // TESTS
    // console.log('Total DM Requirement (tonne/month)', totalDmReqsKeyValues)
    // console.log('Total over all animals', totalDmRequiredAllAnimals)

    this.common.totalDmReqsKeyValues = totalDmReqsKeyValues
    this.common.totalDmRequiredAllAnimals = totalDmRequiredAllAnimals
    return totalDmRequiredAllAnimals
  }

  // Total DM Requirment Combined Enterprises
  totalDmCombinedEnterprises() {
    // Total DM Requirement (tonne/month) over all animals
    let totalDm:number[] = []

    switch (this.$store.state.pasture.simulation.enterprise.toLowerCase()) {
      case 'cattle':
          totalDm = this.common.totalDmRequiredAllAnimals;
        break;
      case 'sheep':
          totalDm = this.common.totalDmRequiredAllAnimals
        break;
      case 'cattle & sheep':
        if (
          !!this.$store.state.cattle &&
          !!this.$store.state.cattle.calculations &&
          !!this.$store.state.sheep &&
          !!this.$store.state.sheep.calculations /*&&
          !!this.$store.state.cattle.calculations.totalDmRequiredAllAnimal &&
          !!this.$store.state.sheep.calculations.totalDmRequiredAllAnimals*/
        ) {
          totalDm = this.$store.state.cattle.calculations.totalDmRequiredAllAnimals.map((ct:number, month:number) => {
            return ct + this.$store.state.sheep.calculations.totalDmRequiredAllAnimals[month]
          })
        } else if (this.enterprise === 'cattle' && this.$store.state.cattle.calculations) {
          totalDm = this.$store.state.cattle.calculations.totalDmRequiredAllAnimals
        } else if (this.enterprise === 'sheep' && this.$store.state.sheep.calculations) {
          totalDm = this.$store.state.sheep.calculations.totalDmRequiredAllAnimals
        }
        break;
      default:
        break;
    }

    // TESTS
    // console.log('Total DM Requirement (tonne/month) over all animals', totalDm)

    this.common.totalDmCombinedEnterprises = totalDm
    return totalDm
  }

  // Pasture
  pasture() {
    const vm = this

    function pastureGrowth(pastureKey?:PastureKeys) {
      // Pasture Growth
      let pasture: any = {
        area: [],
        tonnesMonth: [],
        daysMonth: []
      };
        for (let month = 0; month < 12; month++) {
        const daysMonth = daysInMonth[monthShortNames[vm.months[month]].toLowerCase()]
        const monthlyPasture = store.state.pasture!.monthlyPasture[vm.months[month]]
        // Pasture Area
        let area = 0
        if (pastureKey) {
          area = monthlyPasture[pastureKey].area
        } else {
          if (store.state.pasture!.simulation.growthRateSource === 'Add Pasture Types') {
            area = monthlyPasture.total
          } else {
            area = store.state.pasture!.simulation.area
          }
        }
        pasture.area.push(area);
        // Pasture growth kg/ha/d
        let growth = 0
        if (monthlyPasture) {
          if (pastureKey) {
            growth = monthlyPasture[pastureKey].growth
          } else {
            growth = monthlyPasture.avgGrowth
          }
        }
        if (daysMonth) {
          // Tonnes per month
          pasture.tonnesMonth.push(
            0.001 *
            area *
            growth *
            daysMonth
          );
          // Days in month
          pasture.daysMonth.push(daysMonth)
        }
      }
      return pasture
    }

    // Total pasture
    let totalPastureGrowth:any = pastureGrowth()

    // Single Pasture
    let singlePastureGrowth:any = {}
    this.$store.state.pasture.simulation.pastures.forEach((pasture:any) => {
      singlePastureGrowth[pasture.name] = pastureGrowth(pasture.name)
    });

    let pastureGrowthResults = {
      total: totalPastureGrowth,
      pastures: singlePastureGrowth
    }

    // TESTS
    // console.log('Pasture Growth', pastureGrowthResults)

    this.common.pasture = pastureGrowthResults
    return pastureGrowthResults
  }

  // Supplement: kg/ha/d, tonnes/month, demand not met
  supplement() {
    let totalDm:number[] = this.totalDmCombinedEnterprises()
    let pasture: any = {
      area: [],
    };
    let supplement: any = {
      amount: [],
      tonnesMonth: [],
      demandNotMetBySupplement: [],
    };
    for (let month = 0; month < 12; month++) {
      // Pasture Area
      pasture.area.push(
        store.state.pasture!.simulation.area
      );
      // kg/ha/d
      supplement.amount.push(
        store.state.pasture!.monthlyPasture[this.months[month]].supplement.amount
      )
      // Supplement tonnes per month
      supplement.tonnesMonth.push(
        0.001 *
          pasture.area[month] *
            supplement.amount[month] *
              daysInMonth[monthShortNames[this.months[month]].toLowerCase()]
      );
      // Demand not met by supplement (tonnes/month)
      supplement.demandNotMetBySupplement.push(
        Math.max(0, totalDm[month] - supplement.tonnesMonth[month])
      )
    }

    // TESTS
    // console.log('Supplement', supplement)

    this.common.supplement = supplement
  }

  // Carryover
  carryover() {
    const vm = this
    const wastage = {
      growing: store.state.pasture!.simulation.growingWastage / 100,
      carryover: store.state.pasture!.simulation.carryoverWastage / 100
    }
    const pasture = this.common.pasture.total

    function carryoverAvailableTonnes(pastureKey?:PastureKeys) {
      let carryOverAvailable:number[] = Array.from(Array(12), () => 0);
      let previousStack:any = {
        available: [],
        consumed: [],
        unsatisfied: []
      }

      // Horizontal
      for (let stack = 0; stack < 12; stack++) {
        const demand:any[] = []
        let available:any[] = []
        let consumed:any[] = []
        let unsatisfied:any[] = []

        // Vertical
        for (let month = 0; month < 12; month++) {
          const monthlyPasture = store.state.pasture!.monthlyPasture[vm.months[month]]
          // Pasture growth kg/ha/d
          let pastureGrowth = pastureKey
            ? monthlyPasture[pastureKey].growth
            : monthlyPasture.avgGrowth
          // Total pasture area ha
          let pastureAreaTotal = pastureKey ? monthlyPasture.total : store.state.pasture!.simulation.area
          // Number of days in month
          let monthDays = pasture.daysMonth[month]
          // McNeil carryover calculation
          const lossFactor = stack === 1 ? 1 - wastage.growing : 1 - wastage.carryover;

          // month 0
          if (stack === 0) {
            demand.push(pastureAreaTotal > 0 ? (vm.common.supplement.demandNotMetBySupplement[month] / pastureAreaTotal) * 1000 : 0)
            available.push(pastureGrowth * monthDays)
            consumed.push(Math.min(demand[month], available[month]))
            unsatisfied.push(Math.min(demand[month] - consumed[month]))
          }

          // month 1-11
          if (stack > 0) {
            let lastMonth = mod(month - 1, 12)
            available.push(Math.max(0, lossFactor * (previousStack.available[lastMonth] - previousStack.consumed[lastMonth])))
            consumed.push(Math.min(previousStack.unsatisfied[month], available[month]))
            unsatisfied.push(previousStack.unsatisfied[month] - consumed[month])
          }
        }

        // Set Previous Stack
        previousStack = {
          available: available,
          consumed: consumed,
          unsatisfied: unsatisfied
        }

        // Carryover available (tonnes)
        if (stack > 0) {
          carryOverAvailable = carryOverAvailable.map((ca:number, month:number) => {
            return ca + available[month]
          })
        }

        // if (stack === 0) { console.log('Demand', demand) }
        // console.log('Available from month ' + stack, available)
        // console.log('Consumed from month ' + stack, consumed)
        // console.log('Unsatisfied demand ' + stack, unsatisfied)
        // console.log('Carryover available (tonnes)', carryOverAvailable)

        if (stack === 11) {
          return carryOverAvailable.map((ca:number, month:number) => {
            const pastureArea = pastureKey
            ? store.state.pasture!.monthlyPasture[vm.months[month]][pastureKey].area
            : store.state.pasture!.simulation.area
            return ca * (pastureArea / 1000)
          })
        }
      }
    }

    let totalCarryoverAvailable:any = Array.from(Array(12), () => 0);
    let pastureCarryoverAvailable:any = {}
    if (store.state.pasture!.simulation.growthRateSource === 'Add Pasture Types') {
      this.$store.state.pasture.simulation.pastures.forEach((pasture:any) => {
        // Calculate pasture carryover
        pastureCarryoverAvailable[pasture.name] = carryoverAvailableTonnes(pasture.name)
        // Update total carryover
        totalCarryoverAvailable.map((tca:number, month:number) => {
          totalCarryoverAvailable[month] += pastureCarryoverAvailable[pasture.name][month]
        })
      });
    } else {
      totalCarryoverAvailable = carryoverAvailableTonnes()
    }

    let carryoverResults = {
      total: totalCarryoverAvailable,
      pastures: pastureCarryoverAvailable
    }

    // TESTS
    // console.log(carryoverAvailableTonnes('p1'))
    // console.log(carryoverAvailableTonnes())
    // console.log(carryoverResults)

    this.common.carryover = carryoverResults
    return totalCarryoverAvailable
  }

  // ------------------------------------------------------------
  // ------------------------- KPIs -----------------------------
  // ------------------------------------------------------------

  // Pasture deficit & Pasture demand
  pastureKPI() {
    const pasture = this.common.pasture
    const supplement = this.common.supplement
    const carryover = this.common.carryover

    let totalDm:number[] = this.totalDmCombinedEnterprises()
    let deficitFreshMonths = totalDm.map((tdm:number, month:number) => {
      return (tdm - Math.min(tdm, pasture.total.tonnesMonth[month])) || 0
    })
    
    const sumPastureGrowth = pasture.total.tonnesMonth.reduce((a:number, b:number) => (a || 0) + (b || 0))
    const sumTotalDm = totalDm.length > 0 ? totalDm.reduce((a:number, b:number) => (a || 0) + (b || 0)) : 0

    // Pasture deficit (fresh grown supply)
    let deficitFresh = deficitFreshMonths.length > 0 ? deficitFreshMonths.reduce((a:number, b:number) => a + b) : 0
    // console.log('Pasture deficit, using freshly grown supply', deficitFresh)

    // Pasture deficit (supply with carryover)
    let totalAvailable = pasture.total.tonnesMonth.map((tm:number, month:number) => {
      return tm + (carryover.total[month] || 0)
    })
    let sumOfTotalsAvailable = Array.from(Array(12), () => 0);
    if (this.$store.state.pasture.simulation.growthRateSource === 'Add Pasture Types') {
      Object.keys(pasture.pastures).forEach(key => {
        pasture.pastures[key].tonnesMonth.map((tm:number, month:number) => {
          sumOfTotalsAvailable[month] += (tm + carryover.pastures[key][month])
        })
      })
    }
    /*let totalUnsatisfiedDemand = sumOfTotalsAvailable.map((sta:number, month:number) => {
      return Math.max(0, totalDm[month] - sta)
    })*/
    let totalUnsatisfiedDemand = this.$store.state.pasture.simulation.growthRateSource === 'Add Pasture Types' ? sumOfTotalsAvailable : totalAvailable
    totalUnsatisfiedDemand = totalUnsatisfiedDemand.map((sta:number, month:number) => {
      return Math.max(0, totalDm[month] - sta)
    })

    let deficitCarryover = totalUnsatisfiedDemand.length > 0 ? totalUnsatisfiedDemand.reduce((a:number, b:number) => a + b) : 0
    // console.log('Pasture deficit, using supply with carryover', deficitCarryover)

    // Pasture demand
    let demandAsPercentageOfPasture = sumPastureGrowth === 0 ? 0 : 100 * sumTotalDm / sumPastureGrowth
    // console.log('Pasture demand as a % of pasture grown', demandAsPercentageOfPasture)

    // Minimum Feed On Offer
    let feedOnOffer = totalAvailable.map((sta:number, month:number) => {
      return (sta + supplement.tonnesMonth[month]) / (pasture.total.area[month] > 0 ? pasture.total.area[month] : 1) * 1000
    })
    let minimumFeedOnOffer = feedOnOffer.length > 0 ? feedOnOffer.reduce((a:number, b:number) => Math.min((a || 0), (b || 0))) : 0

    let KPIs = {
      deficitFresh: deficitFresh,
      deficitCarryover: deficitCarryover,
      demandAsPercentageOfPasture: demandAsPercentageOfPasture,
      minimumFeedOnOffer: minimumFeedOnOffer
    }

    // TESTS
    // console.log('Pasture KPIs', KPIs)

    this.common.pastureKPI = KPIs
    return KPIs
  }

  // Liveweight produced
  liveWeightProducedKPI() {
    //let totalDm:number[] = this.common.totalDmCombinedEnterprises;
    const liveWeights = this.common.liveWeight;
    const weightChanges = this.common.weightChange;
    const headOfStock = this.common.headOfStock.count;
    const startFirstPeriod = dayjs(
      cleanDate(StartDates[this.periods[0]], 'D MMM'),
      "D MMM"
    ).dayOfYear();
    const startLastPeriod = dayjs(
      cleanDate(StartDates[this.periods[23]], 'D MMM'),
      "D MMM"
    ).dayOfYear();
    const addJp2:boolean = this.getEnterprise.livestock.joinNumber === 2
    const mothers = this.mothers

    let netWeightProduced: number[] = [];

    // ----- PRODUCTION FIGURES

    let productionFigures:any[] = []

    let actualLiveWeights = liveWeights.map((lws: any, lwsIx: number) => {
      return lws.map((w: number, wIx: number) => {
        return (
          w -
          (dayjs(cleanDate(MidpointDates[this.periods[wIx]], "D MMM"), "D MMM").dayOfYear() -
            dayjs(cleanDate(StartDates[this.periods[wIx]], "D MMM"), "D MMM").dayOfYear()) *
            weightChanges[lwsIx][wIx]
        );
      });
    });
    // console.log('Actual LiveWeights', actualLiveWeights)

    this.stocks.forEach((stock, stockIndex: number) => {
      let p = {
        class: stock.class,
        entry: {
          number: stock.startNumber || 0,
          weight: actualLiveWeights[stockIndex][0] || 0,
        },
        exit: {
          number: headOfStock[stockIndex][23] || 0,
          weight:
            actualLiveWeights[stockIndex][23] +
              weightChanges[stockIndex][23] *
                ((startFirstPeriod < startLastPeriod
                  ? startFirstPeriod + 365
                  : startFirstPeriod) -
                  startLastPeriod -
                  1) || 0,
        },
        sale: {
          number: stock.saleNumber || 0,
          weight: stock.saleWeight || 0,
        },
        purchase: {
          number: stock.purchaseNumber || 0,
          weight: stock.purchaseWeight || 0,
        },
      };

      productionFigures.push(p)
      // console.log('Production Figures', p)

      // Add production figures to net weight produced array
      if (!stock.class.includes("weaned this year")) {
        netWeightProduced.push(
          p.exit.number * p.exit.weight -
            p.entry.number * p.entry.weight +
            p.sale.number * p.sale.weight -
            p.purchase.number * p.purchase.weight
        );
      }
    });

    // ----- CURRENT YEAR'S WEANERS

    let currentYearWeaners:any[] = []

    const weanedData = this.cleanSource(this.common.weanedData)
    const numbersWeaned = this.numbersWeaned()
    const weanedThisYear = this.stocks.filter((stock:any) => stock.class.includes('weaned this year'))[0]
    const weaned = {
      saleDate: dayjs(weanedThisYear.saleDate).format('D MMM'),
      saleNumber: weanedThisYear.saleNumber
    }
    const startDates = AvailableDates.map((ad:AvailableDate) => ad.start)
    const weanedSaleDateIndex = startDates.indexOf(weaned.saleDate)

    mothers.forEach((mother: any, motherIndex: number) => {
      let jp1Index = motherIndex
      let jp2Index = motherIndex + mothers.length

      // Sell #
      let saleNumber = weaned.saleNumber * (
        (
          numbersWeaned.numAtStartPriorToSales.weaned[jp1Index][mod(this.periods.indexOf(weanedSaleDateIndex) + 1, 24)] +
          (addJp2 ? numbersWeaned.numAtStartPriorToSales.weaned[jp2Index][mod(this.periods.indexOf(weanedSaleDateIndex) + 1, 24)] : 0)
          ) /
          (weanedData.weaned[this.periods.indexOf(weanedSaleDateIndex)])
      )

      let p = {
        class: mother,
        exit: {
          number: Math.round(
            weanedData.mothers.weaned.during[jp1Index][23] +
            (addJp2 ? weanedData.mothers.weaned.during[jp2Index][23] : 0)
          ),
          weight: numbersWeaned.actualLiveWeights.weaned[motherIndex][23]
        },
        sale: {
          number: saleNumber,
          weight: numbersWeaned.actualLiveWeights.weaned[motherIndex][mod(this.periods.indexOf(weanedSaleDateIndex) + 1, 24)],
        },
      };

      currentYearWeaners.push(p)
      // console.log('Current years weaners', p)
    });

    // ----- UNWEANED ANIMALS

    let unweanedAnimals:any[] = []

    mothers.forEach((mother: any, motherIndex: number) => {
      let stock = this.stocks.filter((stock) => stock.class === mother)[0];
      let jp1Index = motherIndex
      let jp2Index = motherIndex + mothers.length

      // Mothers Prior To Sales 
      let mothersSoldOn = startDates.indexOf(dayjs(stock.saleDate).format('D MMM')) + 1
      let mothersPriorToSales = 0
      if (this.common.headOfStock.count[motherIndex][this.periods.indexOf(mod(mothersSoldOn + 22, 24)) + 1] > 0) {
        mothersPriorToSales = (
          (
            weanedData.mothers.unweaned.during[jp1Index][this.periods.indexOf(mod(mothersSoldOn + 23, 24)) + 1] +
            (addJp2 ? weanedData.mothers.unweaned.during[jp2Index][this.periods.indexOf(mod(mothersSoldOn + 23, 24)) + 1] : 0)
          ) /
          this.common.headOfStock.count[motherIndex][this.periods.indexOf(mod(mothersSoldOn + 22, 24)) + 1]
        )
      }

    // Mothers After Purchases
      let mothersBoughtOn = startDates.indexOf(dayjs(stock.purchaseDate).format('D MMM')) + 1
      let mothersAfterBuy = 0
        if (this.common.headOfStock.count[motherIndex][this.periods.indexOf(mod(mothersBoughtOn, 24)) + 1] > 0) {
        mothersAfterBuy = (
          (
            weanedData.mothers.unweaned.during[jp1Index][this.periods.indexOf(mod(mothersBoughtOn, 24)) + 1] +
            (addJp2 ? weanedData.mothers.unweaned.during[jp2Index][this.periods.indexOf(mod(mothersBoughtOn, 24)) + 1] : 0)
          ) /
          this.common.headOfStock.count[motherIndex][this.periods.indexOf(mod(mothersBoughtOn, 24)) + 1]
        )
      }

      let p = {
        class: mother,
        entry: {
          number: (
            numbersWeaned.numAtStartPriorToSales.unweaned[jp1Index][0] +
            (addJp2 ? numbersWeaned.numAtStartPriorToSales.unweaned[jp2Index][0] : 0)
          ),
          weight: (
            (
              numbersWeaned.numAtStartPriorToSales.unweaned[jp1Index][0] +
              (addJp2 ? numbersWeaned.numAtStartPriorToSales.unweaned[jp2Index][0] : 0)
            ) > 0
            ? (
                (numbersWeaned.weightAtStartOfPeriod.unweaned[jp1Index][0] * numbersWeaned.numAtStartPriorToSales.unweaned[jp1Index][0]) +
                (addJp2 ? (numbersWeaned.weightAtStartOfPeriod.unweaned[jp2Index][0] * numbersWeaned.numAtStartPriorToSales.unweaned[jp2Index][0]) : 0)
              ) / (numbersWeaned.numAtStartPriorToSales.unweaned[jp1Index][0] + (addJp2 ? numbersWeaned.numAtStartPriorToSales.unweaned[jp2Index][0] : 0))
            : 0
          )
        },
        exit: {
          number: (
            weanedData.mothers.unweaned.during[jp1Index][24] +
            (addJp2 ? weanedData.mothers.unweaned.during[jp2Index][24] : 0)
          ),
          weight: numbersWeaned.actualLiveWeights.unweaned[motherIndex][24]
        },
        sale: {
          number: stock.saleNumber * mothersPriorToSales,
          weight: numbersWeaned.actualLiveWeights.unweaned[motherIndex][mod(this.periods.indexOf(mothersSoldOn), 24)]
        },
        purchase: {
          number: stock.purchaseNumber * mothersAfterBuy,
          weight: numbersWeaned.actualLiveWeights.unweaned[motherIndex][mod(this.periods.indexOf(mothersBoughtOn), 24)]
        }
      };

      unweanedAnimals.push(p)
      // console.log('Unweaned animals', p)
    });

    // Add unweaned and weaned figures to net weight produced array
    mothers.forEach((mother: any, motherIndex: number) => {
      let u = unweanedAnimals[motherIndex]
      let w = currentYearWeaners[motherIndex]

      netWeightProduced.push(
        (
          ((u.exit.number * u.exit.weight) - (u.entry.number * u.entry.weight)) +
          ((u.sale.number * u.sale.weight) - (u.purchase.number * u.purchase.weight))
        ) +
        (
          (w.exit.number * w.exit.weight) + (w.sale.number * w.sale.weight)
        )
      );
    })
    // console.log('Net Weight Produced', netWeightProduced)

    let totalNetWeight = netWeightProduced.reduce((a:number, b:number) => a + b, 0)
    let totalDemand = this.common.totalDmRequiredAllAnimals.reduce((a:number, b:number) => a + b, 0)
    let totalDemandCombined = this.totalDmCombinedEnterprises().reduce((a:number, b:number) => a + b, 0)
    let proportionOfDemand = totalDemand / totalDemandCombined
    let production = {
      kg: totalNetWeight,
      tonnes: totalNetWeight / 1000,
      kgTotal: totalNetWeight / this.$store.state.pasture.simulation.area,
      kgEnterprise: (totalNetWeight / this.$store.state.pasture.simulation.area) / proportionOfDemand
    }

    // TESTS
    // console.log('Production KPIs', production)

    this.common.liveWeightProducedKPI = production
    return production
  }
}
